export const staticText = [
  {
    page: 'listInsuranceClaim',
    label: [
      {
        label_id: 'Portal Asuransi',
        label_en: 'Insurance Portal',
      },
      {
        label_id: 'Ajukan Klaim',
        label_en: 'Submit Claim',
      },
      {
        label_id: 'Pilih Jenis Klaim',
        label_en: 'Select Claim Type',
      },
      {
        label_id: 'Rawat Inap',
        label_en: 'Inpatient',
      },
      {
        label_id: 'Rawat Jalan',
        label_en: 'Outpatient',
      },
      {
        label_id: 'RAWAT INAP',
        label_en: 'INPATIENT',
      },
      {
        label_id: 'RAWAT JALAN',
        label_en: 'OUTPATIENT',
      },
      {
        label_id: 'Pilih Cashless',
        label_en: 'Select Cashless',
      },
      {
        label_id: 'Pilih Penggantian',
        label_en: 'Select Reimbursement',
      },
      {
        label_id: 'Disetujui',
        label_en: 'Approved',
      },
      {
        label_id: 'Ditolak',
        label_en: 'Rejected',
      },
      {
        label_id: 'Menunggu Persetujuan',
        label_en: 'Waiting Approval',
      },
      {
        label_id: 'Selesai',
        label_en: 'Finished',
      },
      {
        label_id: 'Baru',
        label_en: 'New',
      },
      {
        label_id: 'Siap Diekstrak',
        label_en: 'Ready to be Extracted',
      },
      {
        label_id: 'Kelayakan Klaim',
        label_en: 'Claim Eligibility',
      },
      {
        label_id: 'Monitoring Klaim',
        label_en: 'Monitoring Claim',
      },
      {
        label_id: 'Unggah Dokumen Akhir',
        label_en: 'Upload Final Documents',
      },
      {
        label_id: 'Siap Dianalisis',
        label_en: 'Ready for Analysis',
      },
      {
        label_id: 'Siap Di Analisis',
        label_en: 'Ready for Analysis',
      },
      {
        label_id: 'Siap Ditinjau',
        label_en: 'Ready to be Reviewed',
      },
      {
        label_id: 'Sedang Ditinjau',
        label_en: 'Review Ongoing',
      },

      {
        label_id: 'Sedang Analisis',
        label_en: 'Analysis Ongoing',
      },
      {
        label_id: 'Memeriksa FWA',
        label_en: 'Checking FWA',
      },
      {
        label_id: 'Lihat Info',
        label_en: 'View Info',
      },
      {
        label_id: 'Bagaimana AI memutuskan',
        label_en: 'How AI Decides',
      },
      {
        label_id: 'Kepercayaan AI',
        label_en: 'AI Confidence',
      },
      {
        label_id: 'Memeriksa Eligibility',
        label_en: 'Checking Eligibility',
      },
      {
        label_id: 'Revisi',
        label_en: 'Revision',
      },
      {
        label_id: 'Ditanggung Semuanya',
        label_en: 'Covered Everything',
      },
      {
        label_id: 'Persetujuan Sedang Berlangsung',
        label_en: 'Approval Ongoing',
      },
      {
        label_id: 'Kadaluarsa',
        label_en: 'Expired',
      },
      {
        label_id: 'Rawat Inap',
        label_en: 'Inpatient',
      },
      {
        label_id: 'Rawat Jalan',
        label_en: 'Outpatient',
      },
      {
        label_id: 'Ekspor Excel',
        label_en: 'Export Excel',
      },
      {
        label_id: 'Tanggal akhir tidak boleh kosong',
        label_en: 'End date is required',
      },
      {
        label_id: 'Saya',
        label_en: 'Me',
      },
      {
        label_id: 'Pasien',
        label_en: 'Patient',
      },
      {
        label_id: 'Tipe',
        label_en: 'Type',
      },
      {
        label_id: 'Arsipkan',
        label_en: 'Archive',
      },
      {
        label_id: 'Diarsipkan',
        label_en: 'Archived',
      },
      {
        label_id: 'Kirim Ke Analis',
        label_en: 'Send to Analyst',
      },
      {
        label_id: 'Klaim Pending',
        label_en: 'Pending Claim',
      },
      {
        label_id: 'Export Rincian Klaim',
        label_en: 'Export Claim Details',
      },
      {
        label_id: 'Checklist untuk mengeksport detail rincian klaim',
        label_en: 'Check to export detailed claim details',
      },
      {
        label_id: 'Tampilan Kolom',
        label_en: 'Show Columns',
      },
      {
        label_id: 'Pilih Reimbursement',
        label_en: 'Select Reimbursement',
      },
    ],
  },
  {
    page: 'formApplyClaim',
    label: [
      {
        label_id: 'Silakan pilih advisor untuk diassign',
        label_en: 'Please select an advisor to assign',
      },
      {
        label_id: 'Cari nama atau Email',
        label_en: 'Search by name or email',
      },
      {
        label_id: 'Pilih Role',
        label_en: 'Select Role',
      },
      {
        label_id: 'Log Aktifitas',
        label_en: 'Activity Log',
      },
      {
        label_id: 'Saya',
        label_en: 'Me',
      },
      {
        label_id:
          'Pastikan untuk mengisi nomor tiket, nomor polis, dan nomor member terlebih dahulu dengan benar. Verifikasi data tersebut dan periksa kelengkapan dokumen yang diperlukan.',
        label_en:
          'Please ensure that the ticket number, policy number, and member number are filled in correctly first. Verify this data and check the completeness of the required documents.',
      },
      {
        label_id: 'Silakan unggah dokumen yang diminta',
        label_en: 'Please upload the requested documents',
      },
      {
        label_id:
          'Dokumen tambahan yang Anda unggah hanya sebagai dokumen tambahan saja, tidak akan ikut serta di ekstrak.',
        label_en:
          'Additional documents you upload are only as additional documents and will not be included in the extraction.',
      },
      {
        label_id: 'Pemeriksaan Pendaftaran',
        label_en: 'Enrollment Check',
      },
      {
        label_id: 'Verifikasi berhasil!',
        label_en: 'Verification Successful!',
      },
      {
        label_id: 'Informasi Polis',
        label_en: 'Policy Information',
      },
      {
        label_id: 'Status Polis',
        label_en: 'Policy Status',
      },
      {
        label_id: 'Nama Penanggung',
        label_en: 'Name of Guarantor',
      },
      {
        label_id: 'Mata Uang',
        label_en: 'Currency',
      },
      {
        label_id: 'Tipe Kartu',
        label_en: 'Card Type',
      },
      {
        label_id: 'Tanggal Efektif Awal',
        label_en: 'Initial Effective Date',
      },
      {
        label_id: 'Informasi Member',
        label_en: 'Member Information',
      },
      {
        label_id: 'Nama Pasien',
        label_en: 'Patient Name',
      },
      {
        label_id: 'Usia Anggota',
        label_en: 'Member Age',
      },
      {
        label_id: 'Periode',
        label_en: 'Period',
      },
      {
        label_id: 'Pembayaran',
        label_en: 'Payment',
      },
      {
        label_id: 'Pemulihan Kelebihan',
        label_en: 'Overpayment Recovery',
      },
      {
        label_id: 'Nomor Rekening',
        label_en: 'Account Number',
      },
      {
        label_id: 'Nomor Bank',
        label_en: 'Bank Account Number',
      },
      {
        label_id: 'Nomor Pemilik Rekening',
        label_en: 'Account Owner Number',
      },
      {
        label_id: 'Anggota',
        label_en: 'Member',
      },
      {
        label_id: 'Validasi Tag',
        label_en: 'Validate Tag',
      },
      {
        label_id:
          'Memeriksa apakah tag atau label pada data klaim sesuai dengan standar sistem.',
        label_en:
          'Check whether the tags or labels on the claim data comply with system standards.',
      },
      {
        label_id: 'Validasi Dokumen',
        label_en: 'Validate Document',
      },
      {
        label_id:
          'Memastikan dokumen yang diunggah lengkap, terbaca, dan sesuai format yang dibutuhkan.',
        label_en:
          'Ensure uploaded documents are complete, legible, and in the required format.',
      },
      {
        label_id: 'Menganalisa Keaktifan Polis',
        label_en: 'Analyzing Policy Activity',
      },
      {
        label_id: 'AI Sedang melakukan pengecekan detail keaktifan polis.',
        label_en: `AI is currently checking the details of the policy's activity.`,
      },
      {
        label_id: 'Menganalisa Kesesuaian Polis',
        label_en: 'Analyzing Policy Suitability',
      },
      {
        label_id:
          'AI mengekstraksi dan menganalisa informasi penting dari dokumen klaim.',
        label_en: `AI extracts and analyzes critical information from claim documents.`,
      },
      {
        label_id:
          'Langkah ini membutuhkan waktu lebih lama dari yang lain. Mohon menunggu sejenak.',
        label_en: `This step may take longer than the others. Please wait a moment.`,
      },
      {
        label_id: 'Memverifikasi data klaim dengan sistem',
        label_en: `Verifying claim data with the system`,
      },
      {
        label_id:
          'Membandingkan data klaim dengan informasi sistem asuransi untuk verifikasi.',
        label_en: `Compare claim data with insurance system information for verification.`,
      },
      {
        label_id: 'Mencocokan dengan Relevansi Medis',
        label_en: `Matching with Medical Relevance`,
      },
      {
        label_id:
          'Memverifikasi apakah diagnosis dan tindakan medis sesuai dengan pedoman klinis.',
        label_en: `Verifying whether the diagnosis and medical actions are in accordance with clinical guidelines.`,
      },
      {
        label_id: `Membuat Coverage Approval`,
        label_en: `Creating Coverage Approval`,
      },
      {
        label_id: `Mengecek kesesuaian klaim dengan ketentuan polis dan menghasilkan persetujuan manfaat.`,
        label_en: `Checking the suitability of claims with policy provisions and producing benefit approvals.`,
      },
      {
        label_id: `Menggenerate Kesimpulan`,
        label_en: `Generating Conclusions`,
      },
      {
        label_id: `Menyusun ringkasan hasil evaluasi klaim untuk pengambilan keputusan akhir.`,
        label_en: `Compile a summary of the claim evaluation results for final decision making.`,
      },
      {
        label_id: `Tolong upload dokumen!`,
        label_en: `Please upload the document!`,
      },
      {
        label_id: `Silakan untuk upload dokumen klaim asuransi. Pastikan dokumen klaim asuransi lengkap.`,
        label_en: `Please upload your insurance claim documents. Ensure they are complete.`,
      },
      {
        label_id: `Tarik dan jatuhkan file disini, atau`,
        label_en: `Drag and drop files here, or`,
      },
      {
        label_id: `Berikut merupakan dokumen yang perlu diupload`,
        label_en: `The following are the documents that need to be uploaded`,
      },
      {
        label_id:
          'Apakah Anda yakin menerima dokumen ini? Mohon periksa kembali sebelum menerima.',
        label_en:
          'Are you sure accept the document? Please re-check before accpet.',
      },
      {
        label_id:
          'Apakah Anda yakin untuk mengekstrak data klaim? Silakan periksa kembali kelengkapan dokumen sebelum mengekstrak data.',
        label_en:
          'Are you sure to extract the claim data? Please re-check the completeness of the documents before extracting the data.',
      },
      {
        label_id:
          'Apakah Anda yakin untuk mengunggah dokumen final? Silakan periksa kembali kelengkapan dokumen final sebelum mengupload.',
        label_en:
          'Are you sure to upload the final document? Please re-check the completeness of the final documents before uploading.',
      },
      {
        label_id: 'Hapus file dari list?',
        label_en: 'Remove files from the list?',
      },
      {
        label_id: 'Anda yakin untuk menghapus dokumen?',
        label_en: 'Are you sure to remove the document?',
      },
      {
        label_id: 'Dokumen kosong',
        label_en: 'Empty Document',
      },
      {
        label_id: 'Silakan untuk upload dokumen klaim asuransi.',
        label_en: 'Please upload your insurance claim documents.',
      },
      {
        label_id: 'Kirim Dokumen',
        label_en: 'Submit Document',
      },
      {
        label_id: 'Terima Dokumen',
        label_en: 'Accept Document',
      },
      {
        label_id: 'Hapus Dokumen',
        label_en: 'Delete Document',
      },
      {
        label_id: 'Pilih Tag',
        label_en: 'Select Tag',
      },
      {
        label_id: 'Pilih Tag Dokumen',
        label_en: 'Select Document Tag',
      },
      {
        label_id: 'Lembar Medis Awal',
        label_en: 'Initial Medical Sheet',
      },
      {
        label_id: 'Hasil Laboratorium',
        label_en: 'Laboratory Results',
      },
      {
        label_id: 'Surat Pernyataan Pembayaran',
        label_en: 'Payment Statement Letter',
      },
      {
        label_id: 'Surat Kuasa',
        label_en: 'Power of attorney',
      },
      {
        label_id: 'Surat Permintaan Rawat Inap',
        label_en: 'Hospitalization Request Letter',
      },
      {
        label_id: 'Hasil Radiologi (Jika Ada)',
        label_en: 'Radiology Results (If Any)',
      },
      {
        label_id: 'Surat Tindakan',
        label_en: 'Action Letter',
      },
      {
        label_id: 'Surat Jaminan',
        label_en: 'Letter of guarantee',
      },
      {
        label_id: 'Data belum diisi',
        label_en: 'Data not filled in',
      },
      {
        label_id: 'Tanggal Masuk',
        label_en: 'Admission Date',
      },
      {
        label_id: 'Tanggal Keluar',
        label_en: 'Discharge Date',
      },
      {
        label_id: 'Alasan Pending',
        label_en: 'Pending Reason',
      },
      {
        label_id: 'Catatan Pending',
        label_en: 'Pending Note',
      },
      {
        label_id: 'Opsional',
        label_en: 'Optional',
      },
      {
        label_id: 'Tulis catatan di sini',
        label_en: 'Write notes here',
      },
      {
        label_id: 'Verifikasi',
        label_en: 'Verify',
      },
      {
        label_id: 'Memeriksa Data Duplikat',
        label_en: 'Verify Duplicate Data',
      },
      {
        label_id: 'Menghubungkan data klaim dengan data klaim lainnya',
        label_en: 'Linking claim data with other claim data',
      },
    ],
  },
  {
    page: 'Detail Inpatient',
    label: [
      {
        label_id: 'Kelayakan Klaim',
        label_en: 'Claim Eligibility',
        label_my: 'Kelayakan Tuntutan',
      },
      {
        label_id: 'Monitor Progres',
        label_en: 'Progress Monitoring',
        label_my: 'Pemantauan Progres',
      },
      {
        label_id: 'Klaim Final',
        label_en: 'Final Claim',
        label_my: 'Klaim Akhir',
      },
      {
        label_id: 'File PDF tidak tersedia',
        label_en: 'PDF file not available',
        label_my: 'File PDF tidak tersedia',
      },
      {
        label_id: 'Selanjutnya',
        label_en: 'Next',
        label_my: 'Seterusnya',
      },
      {
        label_id: 'Tambah Catatan',
        label_en: 'Add Note',
        label_my: 'Tambah Catatan',
      },
      {
        label_id: 'Ubah Catatan',
        label_en: 'Edit Note',
        label_my: 'Ubah Catatan',
      },
    ],
  },
  {
    page: 'Detail Inpatient Upload',
    label: [
      {
        label_id: 'Upload Dokumen Klaim',
        label_en: 'Upload Claim Document',
        label_my: 'Muat Naik Dokumen Tuntutan',
      },
      {
        label_id: 'Unggah Dokumen Klaim',
        label_en: 'Upload Claim Document',
        label_my: 'Muat Naik Dokumen Tuntutan',
      },
      {
        label_id: 'Unggah Dokumen Final',
        label_en: 'Upload Final Document',
        label_my: 'Muat Naik Dokumen Akhir',
      },
      {
        label_id: 'Unggah Dokumen',
        label_en: 'Upload Document',
        label_my: 'Muat Naik Tuntutan',
      },
      {
        label_id:
          'Silahkan untuk upload dokumen klaim asuransi. Pastikan dokumen klaim asuransi lengkap.',
        label_en:
          'Please upload the insurance claim document. Ensure the document is complete.',
        label_my:
          'Sila muat naik dokumen tuntutan insurans. Pastikan dokumen lengkap.',
      },
      {
        label_id: 'Tarik dan jatuhkan file di sini atau',
        label_en: 'Drag and drop files here or',
        label_my: 'Tarik dan jatuhkan file di sini atau',
      },
      {
        label_id: 'Pilih File',
        label_en: 'Select File',
        label_my: 'Pilih File',
      },
      {
        label_id: 'Batal',
        label_en: 'Cancel',
        label_my: 'Batal',
      },
      {
        label_id: 'List Dokumen',
        label_en: 'Document List',
        label_my: 'Senarai Dokumen',
      },
      {
        label_id: 'Dokumen Kosong',
        label_en: 'Empty Document',
        label_my: 'Dokumen Kosong',
      },
      {
        label_id: 'Silahkan untuk unggah dokumen klaim asuransi.',
        label_en: 'Please upload the insurance claim document.',
        label_my: 'Sila muat naik dokumen tuntutan insurans.',
      },
      {
        label_id: 'Hapus file dari list ?',
        label_en: 'Delete file from list ?',
        label_my: 'Hapus file dari list ?',
      },
      {
        label_id: 'Hapus File',
        label_en: 'Delete File',
        label_my: 'Hapus File',
      },
    ],
  },
  {
    page: 'Detail Inpatient Eligibility',
    label: [
      {
        label_id: 'ID Klaim',
        label_en: 'Claim ID',
        label_my: 'ID Tuntutan',
      },
      {
        label_id: 'Tanggal Permintaan',
        label_en: 'Request Date',
        label_my: 'Tarikh Permintaan',
      },
      {
        label_id: 'Penyedia Asuransi',
        label_en: 'Insurance Provider',
        label_my: 'Penyedia Insurans',
      },
      {
        label_id: 'Nomor Polis',
        label_en: 'Policy Number',
        label_my: 'Nombor Polisi',
      },
      {
        label_id: 'Plan Name',
        label_en: 'Plan Name',
        label_my: 'Nama Pelan',
      },
      {
        label_id: 'Jenis Asuransi',
        label_en: 'Type of Insurance',
        label_my: 'Jenis Insurans',
      },
      {
        label_id: 'Rumah Sakit',
        label_en: 'Hospital',
        label_my: 'Hospital',
      },
      {
        label_id: 'Dokter',
        label_en: 'Doctor',
        label_my: 'Doktor',
      },
      {
        label_id: 'Jumlah Transaksi',
        label_en: 'Total Transaction Amount',
        label_my: 'Jumlah Transaksi',
      },
      {
        label_id: 'Kelayakan Klaim',
        label_en: 'Claim Eligibility',
        label_my: 'Kelayakan Tuntutan',
      },
      {
        label_id: 'Klaim ditolak: belum lewat masa tunggu & masuk blacklist',
        label_en:
          'Claim rejected: not yet past the waiting period & on the blacklist',
        label_my: 'Klaim Ditolak: belum lewat masa tunggu & masuk blacklist',
      },
      {
        label_id: 'Bukti',
        label_en: 'Evidence',
        label_my: 'Bukti',
      },
      {
        label_id: 'Upload Dokumen',
        label_en: 'Upload Document',
        label_my: 'Muat Naik Dokumen',
      },
      {
        label_id: 'Cangkupan Kebijakan',
        label_en: 'Policy Coverage',
        label_my: 'Cangkupan Kebijakan',
      },
      {
        label_id: 'Penyakit yang Dicover',
        label_en: 'Covered Diseases',
        label_my: 'Penyakit yang Dicover',
      },
      {
        label_id: 'Jumlah',
        label_en: 'Amount',
        label_my: 'Jumlah',
      },
      {
        label_id: 'Syarat dan Ketentuan',
        label_en: 'Terms and Conditions',
        label_my: 'Syarat dan Ketentuan',
      },
      {
        label_id: 'Detail Rencana',
        label_en: 'Plan Details',
        label_my: 'Detail Rencana',
      },
      {
        label_id: 'Kelas Kamar',
        label_en: 'Room Class',
        label_my: 'Kelas Bilik',
      },
      {
        label_id: 'Batas ICU',
        label_en: 'ICU Limit',
        label_my: 'Batas ICU',
      },
      {
        label_id: 'Maksimal Klaim',
        label_en: 'Max Claim Cap',
        label_my: 'Maksimal Tuntutan',
      },
      {
        label_id: 'Tabel Manfaat',
        label_en: 'Benefits Table',
        label_my: 'Tabel Manfaat',
      },
      {
        label_id: 'Riwayat Klaim',
        label_en: 'Claim History',
        label_my: 'Riwayat Tuntutan',
      },
      {
        label_id: 'Klaim Ditemukan',
        label_en: 'Claim Found',
        label_my: 'Klaim Ditemukan',
      },
      {
        label_id: 'Total Klaim',
        label_en: 'Total Claims',
        label_my: 'Jumlah Tuntutan',
      },
      {
        label_id: 'Klaim Terakhir',
        label_en: 'Last Claim',
        label_my: 'Klaim Terakhir',
      },
      {
        label_id: 'List riwayat klaim :',
        label_en: 'Claim History List:',
        label_my: 'Senarai Riwayat Tuntutan:',
      },
      {
        label_id: 'Relevan Medis',
        label_en: 'Medical Relevance',
        label_my: 'Relevan Medis',
      },
      {
        label_id: 'Diagnostik & Hasil Lab',
        label_en: 'Diagnostic & Lab Result',
        label_my: 'Diagnostik & Hasil Lab',
      },
      {
        label_id: 'Lokasi',
        label_en: 'Location',
        label_my: 'Lokasi',
      },
      {
        label_id: 'Klinisi',
        label_en: 'Clinician',
        label_my: 'Klinisi',
      },
      {
        label_id: 'Nomor Lab',
        label_en: 'Lab Number',
        label_my: 'Nomor Lab',
      },
      {
        label_id: 'Tanggal Dipesan',
        label_en: 'Order Date',
        label_my: 'Tarikh Dipesan',
      },
      {
        label_id: 'Tanggal Dilaporkan',
        label_en: 'Report Date',
        label_my: 'Tarikh Dilaporkan',
      },
      {
        label_id: 'Tanggal Dicetak',
        label_en: 'Printed Date',
        label_my: 'Tarikh Dicetak',
      },
      {
        label_id: 'Hasil Lab',
        label_en: 'Lab Result',
        label_my: 'Hasil Lab',
      },
      {
        label_id: 'Dokumentasi Pasien & Perawatan',
        label_en: 'Patient & Treatment Documentation',
        label_my: 'Dokumentasi Pesakit & Rawatan',
      },
      {
        label_id: 'Prosedur',
        label_en: 'Procedure',
        label_my: 'Prosedur',
      },
      {
        label_id: 'Diagnosa',
        label_en: 'Diagnosis',
        label_my: 'Diagnosa',
      },
      {
        label_id: 'Keluhan Awal',
        label_en: 'Initial Complaint',
        label_my: 'Keluhan Awal',
      },
      {
        label_id: 'Jenis Perawatan',
        label_en: 'Type of Treatment',
        label_my: 'Jenis Perawatan',
      },
      {
        label_id: 'Catatan Dokter',
        label_en: 'Doctor’s Notes',
        label_my: 'Catatan Dokter',
      },
      {
        label_id: 'Riwayat Dokumen',
        label_en: 'Document History',
        label_my: 'Riwayat Dokumen',
      },
      {
        label_id: 'Unggah Dokumen Tambahan',
        label_en: 'Upload Additional Documents',
        label_my: 'Muat Naik Dokumen Tambahan',
      },
      {
        label_id: 'Upload Dokumen Klaim',
        label_en: 'Upload Claim Document',
        label_my: 'Muat Naik Dokumen Tuntutan',
      },
      {
        label_id:
          'Silahkan untuk upload dokumen klaim asuransi. Pastikan dokumen klaim asuransi lengkap.',
        label_en:
          'Please upload the insurance claim document. Ensure the document is complete.',
        label_my:
          'Sila muat naik dokumen tuntutan insurans. Pastikan dokumen lengkap.',
      },
      {
        label_id: 'Tarik dan jatuhkan file di sini atau',
        label_en: 'Drag and drop files here or',
        label_my: 'Tarik dan jatuhkan file di sini atau',
      },
      {
        label_id: 'Pilih File',
        label_en: 'Select File',
        label_my: 'Pilih File',
      },
      {
        label_id: 'Batal',
        label_en: 'Cancel',
        label_my: 'Batal',
      },
      {
        label_id: 'List Dokumen',
        label_en: 'Document List',
        label_my: 'Senarai Dokumen',
      },
      {
        label_id: 'Dokumen Kosong',
        label_en: 'Empty Document',
        label_my: 'Dokumen Kosong',
      },
      {
        label_id: 'Silahkan untuk upload dokumen klaim asuransi.',
        label_en: 'Please upload the insurance claim document.',
        label_my: 'Sila muat naik dokumen tuntutan insurans.',
      },
      {
        label_id: 'Hapus file dari list ?',
        label_en: 'Delete file from list ?',
        label_my: 'Hapus file dari list ?',
      },
      {
        label_id: 'Hapus File',
        label_en: 'Delete File',
        label_my: 'Hapus File',
      },
      {
        label_id: 'Penyakit',
        label_en: 'Disease',
        label_my: 'Penyakit',
      },
      {
        label_id: 'Kelayakan Eligible',
        label_en: 'Eligible Eligibility',
      },
      {
        label_id: 'Kelayakan Terindikasi Tidak Eligible',
        label_en: 'Indicated Eligibility Not Eligible',
      },
      {
        label_id: 'Tingkat Keyakinan AI',
        label_en: 'AI Confidence Level',
      },
      {
        label_id: 'Faktor Pemeriksaan',
        label_en: 'Examination Factor',
      },
      {
        label_id: 'Keterangan',
        label_en: 'Description',
      },
      {
        label_id: 'Ringkasan Pemeriksaan Kelayakan',
        label_en: 'Eligibility Examination Summary',
      },
      {
        label_id: 'Memenuhi',
        label_en: 'Fulfilled',
      },
      {
        label_id: 'Tidak Memenuhi',
        label_en: 'Not Fulfilled',
      },
      {
        label_id: 'Daftar Pantauan Khusus',
        label_en: 'Special Watchlist',
      },
      {
        label_id: 'Rumah Sakit',
        label_en: 'Hospital',
      },
      {
        label_id: 'dan Dokter',
        label_en: 'and Doctor',
      },
      {
        label_id:
          'masuk dalam daftar pantauan khusus. Silakan tinjau klaim kembali.',
        label_en:
          'entered the special watchlist. Please review the claim again.',
      },
      {
        label_id: 'Riwayat Klaim Pasien',
        label_en: 'Patient Claim History',
      },
      {
        label_id: 'Total Biaya Diajukan',
        label_en: 'Total Submitted Cost',
      },
      {
        label_id: 'Total Biaya Ditanggung',
        label_en: 'Total Covered Cost',
      },
      {
        label_id: 'Penyakit Terakhir',
        label_en: 'Last Disease',
      },
      {
        label_id: 'Klaim Benchmark',
        label_en: 'Claim Benchmark',
      },
      {
        label_id: 'Klaim didapat dari riwayat klaim pasien',
        label_en: 'Claim obtained from patient claim history',
      },
      {
        label_id:
          'Klaim diperoleh dari riwayat klaim sebelumnya yang serupa dengan klaim ini, berdasarkan penyakit atau kode ICD',
        label_en:
          'Claim obtained from previous claim history similar to this claim, based on disease or ICD code',
      },
    ],
  },
  {
    page: 'Detail Inpatient Monitoring',
    label: [
      {
        label_id: 'Upload Progres',
        label_en: 'Upload Progress',
        label_my: 'Progres Muat Naik',
      },
      {
        label_id:
          'Silakan untuk upload dokumen progres klaim asuransi. Pastikan dokumen lengkap.',
        label_en:
          'Please upload the insurance claim progress document. Ensure the document is complete.',
        label_my:
          'Sila muat naik dokumen progres tuntutan insurans. Pastikan dokumen lengkap.',
      },
      {
        label_id: 'Tarik dan jatuhkan file di sini atau',
        label_en: 'Drag and drop files here or',
        label_my: 'Tarik dan jatuhkan file di sini atau',
      },
      {
        label_id: 'Pilih File',
        label_en: 'Select File',
        label_my: 'Pilih File',
      },
      {
        label_id: 'Batal',
        label_en: 'Cancel',
        label_my: 'Batal',
      },
      {
        label_id: 'Analisis File',
        label_en: 'Analyze File',
        label_my: 'Analisis File',
      },
      {
        label_id: 'Timeline Progres Klaim Inpatient',
        label_en: 'Inpatient Claim Progress Timeline',
        label_my: 'Garis Masa Progres Tuntutan Pesakit Dalam',
      },
      {
        label_id: 'Jurnal progres klaim inpatient',
        label_en: 'Inpatient Claim Progress Journal',
        label_my: 'Jurnal Progres Tuntutan Pesakit Dalam',
      },
      {
        label_id: 'Monitoring Progres',
        label_en: 'Progress Monitoring',
        label_my: 'Pemantauan Progres',
      },
      {
        label_id: 'Ringkasan Monitoring',
        label_en: 'Monitoring Summary',
        label_my: 'Ringkasan Pemantauan',
      },
      {
        label_id: 'Kondisi Klinis Membaik',
        label_en: 'Clinical Condition Improving',
        label_my: 'Kondisi Klinis Membaik',
      },
      {
        label_id:
          'Pasien menunjukkan tanda-tanda perbaikan berdasarkan evaluasi medis terbaru. Tidak ada gejala baru yang muncul, dan kondisi vital tetap stabil, mencerminkan efektivitas pengobatan sejauh ini.',
        label_en:
          'The patient shows signs of improvement based on the latest medical evaluation. No new symptoms have emerged, and vital signs remain stable, reflecting the effectiveness of the treatment so far.',
        label_my:
          'Pasien menunjukkan tanda-tanda perbaikan berdasarkan evaluasi medis terbaru. Tidak ada gejala baru yang muncul, dan kondisi vital tetap stabil, mencerminkan efektivitas pengobatan sejauh ini.',
      },
      {
        label_id: 'Ronkhi masih terdengar di paru kanan.',
        label_en: 'Rales are still heard in the right lung.',
        label_my: 'Ronkhi masih terdengar di paru kanan.',
      },
      {
        label_id: 'Batuk minimal.',
        label_en: 'Minimal cough.',
        label_my: 'Batuk minimal.',
      },
      {
        label_id: 'Demam',
        label_en: 'Fever',
        label_my: 'Demam',
      },
      {
        label_id: 'Demam masih >38°C, batuk belum membaik.',
        label_en: 'Fever still >38°C, cough not improving.',
        label_my: 'Demam masih >38°C, batuk belum membaik.',
      },
      {
        label_id: 'Pasien tanpa demam 24 jam terakhir',
        label_en: 'Patient without fever in the last 24 hours',
        label_my: 'Pesakit tanpa demam dalam 24 jam terakhir',
      },
      {
        label_id: 'Operasi Berhasil Dilakukan',
        label_en: 'Surgery Successfully Performed',
        label_my: 'Pembedahan Berjaya Dilakukan',
      },
      {
        label_id:
          'Tindakan operasi telah berhasil dilakukan dan tercatat dalam laporan medis. Tidak ada komplikasi yang dilaporkan pasca-operasi, dan pasien dalam kondisi stabil.',
        label_en:
          'The surgical procedure has been successfully performed and recorded in the medical report. No complications have been reported post-surgery, and the patient is in stable condition.',
        label_my:
          'Tindakan pembedahan telah berjaya dilakukan dan tercatat dalam laporan medis. Tidak ada komplikasi yang dilaporkan pasca-pembedahan, dan pasien dalam kondisi stabil.',
      },
      {
        label_id: 'Infeksi Menurun Berdasarkan Tes Lab',
        label_en: 'Infection Decreased Based on Lab Tests',
        label_my: 'Jangkitan Menurun Berdasarkan Ujian Makmal',
      },
      {
        label_id:
          'Berdasarkan hasil tes laboratorium terbaru, terdapat penurunan kadar infeksi. Tidak ada gejala baru yang muncul, dan kondisi vital tetap stabil, mencerminkan efektivitas pengobatan sejauh ini.',
        label_en:
          'Based on the latest laboratory test results, there is a decrease in infection levels. No new symptoms have emerged, and vital signs remain stable, reflecting the effectiveness of the treatment so far.',
        label_my:
          'Berdasarkan hasil ujian makmal terkini, terdapat penurunan tahap jangkitan. Tiada gejala baru yang muncul, dan tanda vital kekal stabil, mencerminkan keberkesanan rawatan setakat ini.',
      },
      {
        label_id: 'Terapi Lanjutan Belum Dimulai',
        label_en: 'Further Therapy Has Not Yet Started',
        label_my: 'Terapi Lanjutan Belum Dimulai',
      },
      {
        label_id:
          'Terapi lanjutan telah dimulai sesuai rekomendasi dokter penanggung jawab. Tidak ada efek samping yang dilaporkan, dan pasien dalam kondisi stabil.',
        label_en:
          "Further therapy has not yet started as per the responsible doctor's recommendation. No side effects have been reported, and the patient is in stable condition.",
        label_my:
          'Terapi lanjutan belum dimulai sesuai rekomendasi dokter penanggung jawab. Tidak ada efek samping yang dilaporkan, dan pasien dalam kondisi stabil.',
      },
      {
        label_id: 'Imaging Menunjukkan Respons Positif',
        label_en: 'Imaging Shows Positive Response',
        label_my: 'Imaging Menunjukkan Respons Positif',
      },
      {
        label_id:
          'Hasil imaging (X-ray/CT scan) terbaru menunjukkan respons positif terhadap pengobatan. Tidak ada gejala baru yang muncul, dan kondisi vital tetap stabil, mencerminkan efektivitas pengobatan sejauh ini.',
        label_en:
          'The latest imaging results (X-ray/CT scan) show a positive response to treatment. No new symptoms have emerged, and vital signs remain stable, reflecting the effectiveness of the treatment so far.',
        label_my:
          'Hasil imaging (X-ray/CT scan) terkini menunjukkan respons positif terhadap rawatan. Tiada gejala baru yang muncul, dan tanda vital kekal stabil, mencerminkan keberkesanan rawatan setakat ini.',
      },
      {
        label_id: 'Penyakit',
        label_en: 'Disease',
        label_my: 'Penyakit',
      },
      {
        label_id: 'Hari-1',
        label_en: 'Day-1',
        label_my: 'Hari-1',
      },
      {
        label_id: 'Hari-2',
        label_en: 'Day-2',
        label_my: 'Hari-2',
      },
      {
        label_id: 'Ringkasan Update Progres',
        label_en: 'Progress Update Summary',
        label_my: 'Ringkasan Update Progres',
      },
      {
        label_id: 'Relevansi Medis',
        label_en: 'Medical Relevance',
        label_my: 'Relevansi Medis',
      },
      {
        label_id: 'Diagnostik & Hasil Lab',
        label_en: 'Diagnostic & Lab Result',
        label_my: 'Diagnostik & Hasil Lab',
      },
      {
        label_id: 'Lokasi',
        label_en: 'Location',
        label_my: 'Lokasi',
      },
      {
        label_id: 'Klinisi',
        label_en: 'Clinician',
        label_my: 'Klinisi',
      },
      {
        label_id: 'Nomor Lab',
        label_en: 'Lab Number',
        label_my: 'Nomor Lab',
      },
      {
        label_id: 'Tanggal Dipesan',
        label_en: 'Order Date',
        label_my: 'Tarikh Dipesan',
      },
      {
        label_id: 'Tanggal Dilaporkan',
        label_en: 'Report Date',
        label_my: 'Tarikh Dilaporkan',
      },
      {
        label_id: 'Tanggal Dicetak',
        label_en: 'Printed Date',
        label_my: 'Tarikh Dicetak',
      },
      {
        label_id: 'Hasil Lab',
        label_en: 'Lab Result',
        label_my: 'Hasil Lab',
      },
      {
        label_id: 'Analisis Masa Lalu',
        label_en: 'Past Analysis',
        label_my: 'Analisis Masa Lalu',
      },
      {
        label_id: 'Dokumentasi Pasien & Perawatan',
        label_en: 'Patient & Treatment Documentation',
        label_my: 'Dokumentasi Pesakit & Rawatan',
      },
      {
        label_id: 'Prosedur',
        label_en: 'Procedure',
        label_my: 'Prosedur',
      },
      {
        label_id: 'Diagnosa',
        label_en: 'Diagnosis',
        label_my: 'Diagnosa',
      },
      {
        label_id: 'Keluhan Awal',
        label_en: 'Initial Complaint',
        label_my: 'Keluhan Awal',
      },
      {
        label_id: 'Jenis Perawatan',
        label_en: 'Type of Treatment',
        label_my: 'Jenis Perawatan',
      },
      {
        label_id: 'Catatan Dokter',
        label_en: 'Doctor’s Notes',
        label_my: 'Catatan Dokter',
      },
      {
        label_id: 'Penyakit yang Dicover',
        label_en: 'Covered Diseases',
        label_my: 'Penyakit yang Dicover',
      },
      {
        label_id: 'Jumlah',
        label_en: 'Amount',
        label_my: 'Jumlah',
      },
      {
        label_id: 'Syarat dan Ketentuan',
        label_en: 'Terms and Conditions',
        label_my: 'Syarat dan Ketentuan',
      },
      {
        label_id: 'TOTAL',
        label_en: 'TOTAL',
        label_my: 'Jumlah',
      },
      {
        label_id: 'Detail Layanan',
        label_en: 'Service Details',
        label_my: 'Detail Perkhidmatan',
      },
      {
        label_id: 'Kelas Kamar',
        label_en: 'Room Class',
        label_my: 'Kelas Kamar',
      },
      {
        label_id: 'Batas ICU',
        label_en: 'ICU Limit',
        label_my: 'Batas ICU',
      },
      {
        label_id: 'Maksimal Klaim',
        label_en: 'Max Claim Cap',
        label_my: 'Maksimal Tuntutan',
      },
      {
        label_id: 'Tabel Manfaat',
        label_en: 'Benefits Table',
        label_my: 'Tabel Manfaat',
      },
      {
        label_id: 'Riwayat Klaim',
        label_en: 'Claim History',
        label_my: 'Riwayat Tuntutan',
      },
      {
        label_id: 'Klaim Ditemukan',
        label_en: 'Claim Found',
        label_my: 'Klaim Ditemukan',
      },
      {
        label_id: 'Total Klaim',
        label_en: 'Total Claims',
        label_my: 'Jumlah Tuntutan',
      },
      {
        label_id: 'Klaim Terakhir',
        label_en: 'Last Claim',
        label_my: 'Klaim Terakhir',
      },
      {
        label_id: 'List riwayat klaim :',
        label_en: 'Claim History List:',
        label_my: 'Senarai Riwayat Tuntutan:',
      },
      {
        label_id: 'Relevan Medis',
        label_en: 'Medical Relevance',
        label_my: 'Relevan Medis',
      },
      {
        label_id: 'Dokumen pendukung',
        label_en: 'Supporting Documents',
        label_my: 'Dokumen Pendukung',
      },
      {
        label_id: 'Data Kosong',
        label_en: 'Empty Data',
        label_my: 'Data Kosong',
      },
      {
        label_id: 'Hapus file dari list ?',
        label_en: 'Delete file from list ?',
        label_my: 'Hapus file dari list ?',
      },
      {
        label_id: 'Hapus File',
        label_en: 'Delete File',
        label_my: 'Hapus File',
      },
      {
        label_id: 'Tanggal Dokumen',
        label_en: 'Document Date',
      },
      {
        label_id: 'Hapus TanggalDokumen',
        label_en: 'Delete Document Date',
      },
      {
        label_id:
          'Apakah anda yakin untuk menghapus tanggal dokumen? Tanggal dokumen yang Anda hapus akan terhapus beserta semua dokumen di dalamnya',
        label_en:
          'Are you sure you want to delete the document date? The document date you delete will be deleted along with all the documents inside it',
      },
    ],
  },
  {
    page: 'Table List Riwayat Klaim',
    label: [
      {
        label_id: 'Klaim ID',
        label_en: 'Claim ID',
        label_my: 'ID Tuntutan',
      },
      {
        label_id: 'Penyakit',
        label_en: 'Disease',
        label_my: 'Penyakit',
      },
      {
        label_id: 'Prosedur',
        label_en: 'Procedure',
        label_my: 'Prosedur',
      },
      {
        label_id: 'Rumah Sakit',
        label_en: 'Hospital',
        label_my: 'Hospital',
      },
      {
        label_id: 'Kelas',
        label_en: 'Class',
        label_my: 'Kelas',
      },
      {
        label_id: 'Wilayah',
        label_en: 'Region',
        label_my: 'Wilayah',
      },
      {
        label_id: 'Dokter',
        label_en: 'Doctor',
        label_my: 'Doktor',
      },
      {
        label_id: 'Harga',
        label_en: 'Price',
        label_my: 'Harga',
      },
      {
        label_id: 'DoL Masuk',
        label_en: 'Date of Loss',
      },
    ],
  },
  {
    page: 'Table Manfaat',
    label: [
      {
        label_id: 'Manfaat Polis',
        label_en: 'Policy Benefits',
        label_my: 'Manfaat Polis',
      },
      {
        label_id: 'Batas Polis',
        label_en: 'Policy Limit',
        label_my: 'Batas Polis',
      },
      {
        label_id: 'Biaya Diajukan',
        label_en: 'Proposed Cost',
        label_my: 'Biaya Diajukan',
      },
      {
        label_id: 'Biaya Diajukan',
        label_en: 'Proposed Cost',
        label_my: 'Biaya Diajukan',
      },
      {
        label_id: 'Biaya Disetujui',
        label_en: 'Approved Cost',
        label_my: 'Biaya Disetujui',
      },
      {
        label_id: 'Biaya Tidak Ditanggung',
        label_en: 'Uncovered Cost',
        label_my: 'Biaya Tidak Ditanggung',
      },
      {
        label_id: 'Klaim Diajukan',
        label_en: 'Claim Submitted',
        label_my: 'Klaim Diajukan',
      },
      {
        label_id: 'Klaim Disetujui',
        label_en: 'Claim Approved',
        label_my: 'Klaim Disetujui',
      },
      {
        label_id: 'Nama Item',
        label_en: 'Item Name',
        label_my: 'Nama Item',
      },
      {
        label_id: 'Kategori',
        label_en: 'Category',
        label_my: 'Kategori',
      },
      {
        label_id: 'Kuantiti',
        label_en: 'Quantity',
        label_my: 'Kuantiti',
      },
      {
        label_id: 'Tanggal Invoice',
        label_en: 'Invoice Date',
        label_my: 'Tanggal Invoice',
      },
      {
        label_id: 'Total Invoice',
        label_en: 'Total Invoice',
        label_my: 'Total Invoice',
      },
    ],
  },
  {
    page: 'Table Status Coverage',
    label: [
      {
        label_id: 'Manfaat Polis',
        label_en: 'Policy Benefits',
        label_my: 'Manfaat Polis',
      },
      {
        label_id: 'Batas Polis',
        label_en: 'Policy Limit',
        label_my: 'Batas Polis',
      },
      {
        label_id: 'Biaya Diajukan',
        label_en: 'Proposed Cost',
        label_my: 'Biaya Diajukan',
      },
      {
        label_id: 'Biaya Diajukan',
        label_en: 'Proposed Cost',
        label_my: 'Biaya Diajukan',
      },
      {
        label_id: 'Biaya Disetujui',
        label_en: 'Approved Cost',
        label_my: 'Biaya Disetujui',
      },
      {
        label_id: 'Biaya Tidak Ditanggung',
        label_en: 'Uncovered Cost',
        label_my: 'Biaya Tidak Ditanggung',
      },
      {
        label_id: 'Syarat dan Ketentuan',
        label_en: 'Terms and Conditions',
        label_my: 'Syarat dan Ketentuan',
      },
      {
        label_id: 'Cakupan Analisis',
        label_en: 'Coverage Analysis',
        label_my: 'Cakupan Analisis',
      },
      {
        label_id: 'Polis',
        label_en: 'Policy',
        label_my: 'Polis',
      },
      {
        label_id: 'Lihat Polis',
        label_en: 'View Policy',
        label_my: 'Lihat Polis',
      },
      {
        label_id: 'Produk/Plan',
        label_en: 'Product/Plan',
        label_my: 'Produk/Plan',
      },
      {
        label_id: 'Mulai Pertanggungan',
        label_en: 'Coverage Start',
        label_my: 'Mulai Pertanggungan',
      },
      {
        label_id: 'Akhir Pertanggungan',
        label_en: 'Coverage End',
        label_my: 'Akhir Pertanggungan',
      },
      {
        label_id: 'Sesuai Batas Polis',
        label_en: 'Within Policy Limit',
      },
      {
        label_id: 'Anda yakin untuk menyetujui semua item di dalam kategori',
        label_en: 'Are you sure to approve all items in the category',
      },
      {
        label_id:
          'ditanggung semuanya? Biaya semua item akan ditanggung semuanya.',
        label_en:
          'are fully covered? The cost of all items will be fully covered.',
      },
      {
        label_id: 'Anda yakin untuk menolak semua item di dalam kategori',
        label_en: 'Are you sure to reject all items in the category',
      },
      {
        label_id: 'Biaya semua item akan ditolak semuanya.',
        label_en: 'The cost of all items will be rejected.',
      },
      {
        label_id: 'Ubah Biaya Ditanggung',
        label_en: 'Change Covered Cost',
      },
      {
        label_id: 'Semuanya',
        label_en: 'All',
      },
      {
        label_id: 'Sebagian',
        label_en: 'Partial',
      },
      {
        label_id: 'Harga Item',
        label_en: 'Item Price',
      },
      {
        label_id: 'Nama Item',
        label_en: 'Item Name',
      },
    ],
  },
  {
    page: 'Table TripleNested',
    label: [
      {
        label_id: 'Nama Biaya',
        label_en: 'Cost Name',
        label_my: 'Nama Biaya',
      },
      {
        label_id: 'Hari ke',
        label_en: 'Day',
        label_my: 'Hari ke',
      },
      {
        label_id: 'Butuh Konformasi',
        label_en: 'Needs Confirmation',
        label_my: 'Butuh Konformasi',
      },
      {
        label_id: 'Melebihi HET',
        label_en: 'Exceeds HET',
        label_my: 'Melebihi HET',
      },
      {
        label_id: 'Item Butuh Konformasi',
        label_en: 'Item Needs Confirmation',
        label_my: 'Item Butuh Konformasi',
      },
      {
        label_id: 'Harga',
        label_en: 'Price',
        label_my: 'Harga',
      },
    ],
  },
  {
    page: 'Table Rincian Invoice',
    label: [
      {
        label_id: 'Nama Biaya',
        label_en: 'Cost Name',
        label_my: 'Nama Biaya',
      },
      {
        label_id: 'Harga',
        label_en: 'Price',
        label_my: 'Harga',
      },
      {
        label_id: 'Data Kosong',
        label_en: 'No Data',
        label_my: 'Data Kosong',
      },
      {
        label_id: 'Konfirmasi',
        label_en: 'Confirmation',
        label_my: 'Konfirmasi',
      },
      {
        label_id: 'untuk menggunakan fraud detection',
        label_en: 'To use fraud detection',
        label_my: 'Untuk menggunakan fraud detection',
      },
      {
        label_id: 'Konfirmasi Riwayat Klaim',
        label_en: 'Claim History Confirmation',
        label_my: 'Konfirmasi Riwayat Klaim',
      },
      {
        label_id: 'Konfirmasi Riwayat Klaim untuk membandingkan Riwayat Klaim',
        label_en: 'Claim History Confirmation for comparing Claim History',
        label_my: 'Konfirmasi Riwayat Klaim untuk membandingkan Riwayat Klaim',
      },
      {
        label_id: 'Butuh Konfirmasi',
        label_en: 'Needs Confirmation',
        label_my: 'Butuh Konfirmasi',
      },
      {
        label_id:
          'Anda memiliki perubahan yang belum disimpan. Apakah Anda yakin ingin beralih tab? Perubahan akan hilang.',
        label_en:
          'You have unsaved changes. Are you sure you want to switch tabs? Changes will be lost.',
        label_my:
          'Anda memiliki perubahan yang belum disimpan. Apakah Anda yakin ingin beralih tab? Perubahan akan hilang.',
      },
      {
        label_id:
          'Anda memiliki perubahan yang belum disimpan. Apakah Anda yakin ingin batal? Perubahan akan hilang.',
        label_en:
          'You have unsaved changes. Are you sure you want to cancel? Changes will be lost.',
        label_my:
          'Anda memiliki perubahan yang belum disimpan. Apakah Anda yakin ingin batal? Perubahan akan hilang.',
      },
      {
        label_id:
          'Anda yakin untuk membatalkan perubahan? Semua perubahan yang Anda lakukan akan hilang.',
        label_en:
          'Are you sure you want to cancel the changes? All changes you made will be lost.',
        label_my:
          'Adakah anda pasti mahu membatalkan perubahan? Semua perubahan yang anda buat akan hilang.',
      },
    ],
  },
  {
    page: 'Detail Inpatient Final',
    label: [
      {
        label_id: 'ID Klaim',
        label_en: 'Claim ID',
        label_my: 'ID Tuntutan',
      },
      {
        label_id: 'Tanggal Permintaan',
        label_en: 'Request Date',
        label_my: 'Tarikh Permintaan',
      },
      {
        label_id: 'Penyedia Asuransi',
        label_en: 'Insurance Provider',
        label_my: 'Penyedia Insurans',
      },
      {
        label_id: 'Nomor Polis',
        label_en: 'Policy Number',
        label_my: 'Nombor Polisi',
      },
      {
        label_id: 'Plan Name',
        label_en: 'Plan Name',
        label_my: 'Nama Pelan',
      },
      {
        label_id: 'Jenis Asuransi',
        label_en: 'Type of Insurance',
        label_my: 'Jenis Insurans',
      },
      {
        label_id: 'Rumah Sakit',
        label_en: 'Hospital',
        label_my: 'Hospital',
      },
      {
        label_id: 'Dokter',
        label_en: 'Doctor',
        label_my: 'Doktor',
      },
      {
        label_id: 'Jumlah Transaksi',
        label_en: 'Total Transaction Amount',
        label_my: 'Jumlah Transaksi',
      },
      {
        label_id: 'Ubah Ringkasan',
        label_en: 'Edit Summary',
        label_my: 'Ubah Ringkasan',
      },
      {
        label_id: 'Ubah Ringkasan Informasi Umum',
        label_en: 'Edit General Information Summary',
        label_my: 'Ubah Ringkasan Informasi Umum',
      },
      {
        label_id: 'Ubah Ringkasan Polis',
        label_en: 'Edit Policy Summary',
        label_my: 'Ubah Ringkasan Polisi',
      },
      {
        label_id: 'Ubah Ringkasan Rincian Invoice',
        label_en: 'Edit Invoice Details Summary',
        label_my: 'Ubah Ringkasan Rincian Invoice',
      },
      {
        label_id: 'Ubah Ringkasan Diagnosis',
        label_en: 'Edit Diagnosis Summary',
        label_my: 'Ubah Ringkasan Diagnosis',
      },
      {
        label_id: 'Ubah Ringkasan Riwayat Klaim',
        label_en: 'Edit Claim History Summary',
        label_my: 'Ubah Ringkasan Riwayat Tuntutan',
      },
      {
        label_id: 'Ubah Ringkasan Buku Tarif',
        label_en: 'Edit Tariff Book Summary',
        label_my: 'Ubah Ringkasan Buku Tarif',
      },
      {
        label_id: 'Ubah Ringkasan Relevansi Medis',
        label_en: 'Edit Medical Relevance Summary',
        label_my: 'Ubah Ringkasan Relevansi Perubatan',
      },
      {
        label_id: 'Ubah Ringkasan HET',
        label_en: 'Edit HET Summary',
        label_my: 'Ubah Ringkasan HET',
      },
      {
        label_id: 'Ringkasan Klaim',
        label_en: 'Claim Summary',
        label_my: 'Ringkasan Tuntutan',
      },
      {
        label_id: 'Ringkasan Cakupan',
        label_en: 'Coverage Summary',
        label_my: 'Ringkasan Cakupan',
      },
      {
        label_id: 'Ringkasan Buku Tarif',
        label_en: 'Tariff Book Summary',
        label_my: 'Ringkasan Buku Tarif',
      },
      {
        label_id: 'Ringkasan Biaya Klaim',
        label_en: 'Claim Cost Summary',
        label_my: 'Ringkasan Biaya Klaim',
      },
      {
        label_id: 'Ringkasan Riwayat Klaim Pasien',
        label_en: 'Patient Claim History Summary',
        label_my: 'Ringkasan Riwayat Tuntutan Pesakit',
      },
      {
        label_id: 'Lama Rawat Inap',
        label_en: 'Length of Stay',
        label_my: 'Lama Rawat Inap',
      },
      {
        label_id: 'Hari',
        label_en: 'Day',
        label_my: 'Hari',
      },
      {
        label_id: 'Total Invoice',
        label_en: 'Total Invoice',
        label_my: 'Total Invoice',
      },
      {
        label_id: 'Total Klaim Disetujui',
        label_en: 'Total Approved Claims',
        label_my: 'Total Klaim Disetujui',
      },
      {
        label_id: 'Jumlah Kelebihan',
        label_en: 'Total Uncovered Cost',
        label_my: 'Jumlah Kelebihan',
      },
      {
        label_id: 'Penetapan Harga Obat',
        label_en: 'Drug Price Setting',
        label_my: 'Penetapan Harga Obat',
      },
      {
        label_id: 'Harga yang Disepakati',
        label_en: 'Agreed Price',
        label_my: 'Harga yang Disepakati',
      },
      {
        label_id: 'Item Perlu Diverifikasi',
        label_en: 'Item Needs Verification',
        label_my: 'Item Perlu Diverifikasi',
      },
      {
        label_id: 'Policy & Informasi Klaim',
        label_en: 'Policy & Claim Information',
        label_my: 'Policy & Informasi Tuntutan',
      },
      {
        label_id: 'Detail Klaim',
        label_en: 'Claim Details',
        label_my: 'Rincian Tuntutan',
      },
      {
        label_id: 'Bandingkan MIMS',
        label_en: 'Compare MIMS',
        label_my: 'Bandingkan MIMS',
      },
      {
        label_id: 'Bandingkan Buku Tarif',
        label_en: 'Compare Tariff Book',
        label_my: 'Bandingkan Buku Tarif',
      },
      {
        label_id: 'Relevansi Medis',
        label_en: 'Medical Relevance',
        label_my: 'Relevansi Perubatan',
      },
      {
        label_id: 'Riwayat Klaim',
        label_en: 'Claim History',
        label_my: 'Riwayat Tuntutan',
      },
      {
        label_id: 'Cakupan Kebijakan',
        label_en: 'Policy Coverage',
        label_my: 'Cakupan Polisi',
      },
      {
        label_id: 'Cakupan Polis',
        label_en: 'Policy Coverage',
        label_my: 'Cakupan Polisi',
      },
      {
        label_id: 'Tanggung Semuanya',
        label_en: 'Fully Covered',
        label_my: 'Ditanggung Sepenuhnya',
      },
      {
        label_id: 'Tolak Semuanya',
        label_en: 'Reject Everything',
        label_my: 'Tolak Semuanya',
      },
      {
        label_id: 'Ditanggung Sebagian',
        label_en: 'Partially Covered',
        label_my: 'Ditanggung Sebagian',
      },
      {
        label_id: 'Ditanggung Sepenuhnya',
        label_en: 'Fully Covered',
        label_my: 'Ditanggung Sepenuhnya',
      },
      {
        label_id: 'Ditanggung',
        label_en: 'Covered',
        label_my: 'Ditanggung',
      },
      {
        label_id: 'Tidak Ditanggung',
        label_en: 'Not Covered',
        label_my: 'Tidak Ditanggung',
      },
      {
        label_id: 'Ditanggung sebagian',
        label_en: 'Partially Covered',
        label_my: 'Ditanggung sebagian',
      },
      {
        label_id: 'Tidak Ditanggung',
        label_en: 'Not Covered',
        label_my: 'Tidak Ditanggung',
      },
      {
        label_id: 'Dokumen Polis Tidak Ditemukan',
        label_en: 'Policy Document Not Found',
        label_my: 'Dokumen Polisi Tidak Ditemukan',
      },
      {
        label_id: 'Rincian Invoice',
        label_en: 'Invoice Details',
        label_my: 'Rincian Invoice',
      },
      {
        label_id: 'item dipilih',
        label_en: 'Choosed Item',
        label_my: 'item dipilih',
      },
      {
        label_id: 'Pindahkan',
        label_en: 'Move',
        label_my: 'Pindahkan',
      },
      {
        label_id: 'Sepakati Semuanya',
        label_en: 'Agree All',
        label_my: 'Setuju Semua',
      },
      {
        label_id: 'Batalkan pilihan',
        label_en: 'Cancel Selection',
        label_my: 'Batalkan pilihan',
      },
      {
        label_id: 'Silakan centang kolom untuk ditampilkan.',
        label_en: 'Please check the fields to display.',
        label_my: 'Sila tandakan ruangan untuk dipaparkan.',
      },
      {
        label_id: 'Apakah anda yakin untuk menyepakati',
        label_en: 'Are you sure to agree to the',
        label_my: 'Adakah anda pasti bersetuju dengan',
      },
      {
        label_id: 'klaim berikut',
        label_en: 'claims below',
        label_my: 'tuntutan berikut',
      },
      {
        label_id: 'Klaim sedang diproses',
        label_en: 'Claims are being processed',
        label_my: 'Tuntutan sedang diproses',
      },
      {
        label_id: 'Klaim telah berhasil disepakati',
        label_en: 'Claims have been successfully approved',
        label_my: 'Tuntutan telah berjaya dipersetujui',
      },
      {
        label_id: 'Klaim berhasil disepakati',
        label_en: 'Claim successfully confirmed',
        label_my: 'Tuntutan berjaya dipersetujui',
      },
      {
        label_id: 'sedangkan',
        label_en: 'whereas',
        label_my: 'sedangkan',
      },
      {
        label_id:
          'Klaim tidak dapat disepakati karena tidak adanya catatan dalam klaim tersebut',
        label_en:
          'The claim cannot be approved due to the absence of any records in the claim.',
        label_my:
          'Tuntutan tersebut tidak dapat diluluskan kerana ketiadaan sebarang rekod dalam tuntutan tersebut.',
      },
      {
        label_id: 'Semua Klaim gagal disepakati',
        label_en: 'All Claims failed to be agreed upon',
        label_my: 'Semua Tuntutan gagal dipersetujui',
      },
      {
        label_id:
          'Klaim yang telah disepakati tidak dapat dikembalikan statusnya.',
        label_en: 'Agreed claims cannot have their status reverted.',
        label_my:
          'Tuntutan yang telah dipersetujui tidak boleh dikembalikan statusnya.',
      },
      {
        label_id: 'Silakan memilih kategori item.',
        label_en: 'Please select an item category.',
        label_my: 'Sila pilih kategori item.',
      },
      {
        label_id: 'Pilih Kategori',
        label_en: 'Select Category',
      },
      {
        label_id: 'Informasi Pasien',
        label_en: 'Patient Information',
        label_my: 'Informasi Pesakit',
      },
      {
        label_id: 'Informasi Asuransi',
        label_en: 'Insurance Information',
        label_my: 'Informasi Insurans',
      },
      {
        label_id: 'Informasi Klaim',
        label_en: 'Claim Information',
        label_my: 'Informasi Tuntutan',
      },
      {
        label_id: 'Informasi Surat Jaminan & Reimbursement',
        label_en: 'Guarantee Letter & Reimbursement Information',
        label_my: 'Informasi Surat Jaminan & Reimbursement',
      },
      {
        label_id: 'Informasi Rumah Sakit',
        label_en: 'Hospital Information',
        label_my: 'Informasi Hospital',
      },
      {
        label_id: 'Informasi Diagnosis',
        label_en: 'Diagnosis Information',
        label_my: 'Informasi Diagnosis',
      },
      {
        label_id: 'Informasi Laboratorium',
        label_en: 'Laboratory Information',
        label_my: 'Informasi Laboratorium',
      },
      {
        label_id: 'Ya',
        label_en: 'Yes',
        label_my: 'Ya',
      },
      {
        label_id: 'Tidak',
        label_en: 'No',
        label_my: 'Tidak',
      },
      {
        label_id: 'Batal',
        label_en: 'Cancel',
        label_my: 'Batal',
      },
      {
        label_id: 'Batal Edit',
        label_en: 'Cancel Edit',
        label_my: 'Batal Edit',
      },
      {
        label_id: 'Ubah',
        label_en: 'Edit',
        label_my: 'Ubah',
      },
      {
        label_id: 'Simpan',
        label_en: 'Save',
        label_my: 'Simpan',
      },
      {
        label_id: 'Simpan Perubahan',
        label_en: 'Save Changes',
        label_my: 'Simpan Perubahan',
      },
      {
        label_id: 'Tambah Item',
        label_en: 'Add Item',
        label_my: 'Tambah Item',
      },
      {
        label_id: 'Tanggal Lahir',
        label_en: 'Date of Birth',
        label_my: 'Tarikh Lahir',
      },
      {
        label_id: 'Jenis Kelamin',
        label_en: 'Gender',
        label_my: 'Jantina',
      },
      {
        label_id: 'Penyedia Asuransi',
        label_en: 'Insurance Provider',
        label_my: 'Penyedia Insurans',
      },
      {
        label_id: 'Nomor Polis',
        label_en: 'Policy Number',
        label_my: 'Nombor Polisi',
      },
      {
        label_id: 'Nomor Indeks',
        label_en: 'Index Number',
        label_my: 'Nombor Indeks',
      },
      {
        label_id: 'Jenis Asuransi',
        label_en: 'Type of Insurance',
        label_my: 'Jenis Insurans',
      },
      {
        label_id: 'Kategori Klaim',
        label_en: 'Type of Claim',
        label_my: 'Jenis Tuntutan',
      },
      {
        label_id: 'Nama Kategori',
        label_en: 'Category Name',
        label_my: 'Nama Kategori',
      },
      {
        label_id: 'Nama Analis',
        label_en: 'Analyst Name',
        label_my: 'Nama Penganalisis',
      },
      {
        label_id: 'Kelas',
        label_en: 'Class',
        label_my: 'Kelas',
      },
      {
        label_id: 'Tipe Admisi',
        label_en: 'Type of Admission',
        label_my: 'Tipe Kemasukan',
      },
      {
        label_id: 'Jenis Transaksi Klaim',
        label_en: 'Type of Claim Transaction',
        label_my: 'Jenis Transaksi Tuntutan',
      },
      {
        label_id: 'Tanggal Terima Klaim',
        label_en: 'Claim Received Date',
        label_my: 'Tarikh Terima Tuntutan',
      },
      {
        label_id: 'Bentuk Berkas',
        label_en: 'Document Type',
        label_my: 'Bentuk Dokumen',
      },
      {
        label_id: 'No. REF dari GAF',
        label_en: 'No. REF from GAF',
        label_my: 'No. REF dari GAF',
      },
      {
        label_id: 'Prioritas',
        label_en: 'Priority',
        label_my: 'Prioriti',
      },
      {
        label_id: 'Jenis Transaksi',
        label_en: 'Transaction Type',
        label_my: 'Jenis Transaksi',
      },
      {
        label_id: 'Mata Uang',
        label_en: 'Currency',
        label_my: 'Mata Wang',
      },
      {
        label_id: 'Jumlah Transaksi',
        label_en: 'Total Transaction Amount',
        label_my: 'Jumlah Transaksi',
      },
      {
        label_id: 'Catatan',
        label_en: 'Notes',
        label_my: 'Catatan',
      },
      {
        label_id: 'No surat Jaminan',
        label_en: 'Guarantee Letter No.',
        label_my: 'No Surat Jaminan',
      },
      {
        label_id: 'Tanggal Surat Jaminan',
        label_en: 'Guarantee Letter Date',
        label_my: 'Tarikh Surat Jaminan',
      },
      {
        label_id: 'No Surat PP (Reimbursement)',
        label_en: 'Reimbursement Letter No.',
        label_my: 'No Surat PP (Reimbursement)',
      },
      {
        label_id: 'Tanggal Surat PP (Reimbursement)',
        label_en: 'Reimbursement Letter Date',
        label_my: 'Tarikh Surat PP (Reimbursement)',
      },
      {
        label_id: 'Nama Rumah Sakit',
        label_en: 'Hospital Name',
        label_my: 'Nama Hospital',
      },
      {
        label_id: 'Dokter',
        label_en: 'Doctor',
        label_my: 'Doktor',
      },
      {
        label_id: 'Wilayah',
        label_en: 'Region',
        label_my: 'Wilayah',
      },
      {
        label_id: 'Alamat',
        label_en: 'Address',
        label_my: 'Alamat',
      },
      {
        label_id: 'Nominal Tagihan',
        label_en: 'Invoice Amount',
        label_my: 'Jumlah Invois',
      },
      {
        label_id: 'Klinisi',
        label_en: 'Clinician',
        label_my: 'Klinisi',
      },
      {
        label_id: 'Nomor Lab',
        label_en: 'Lab Number',
        label_my: 'Nomor Lab',
      },
      {
        label_id: 'Tanggal Dipesan',
        label_en: 'Order Date',
        label_my: 'Tarikh Dipesan',
      },
      {
        label_id: 'Tanggal Dilaporkan',
        label_en: 'Report Date',
        label_my: 'Tarikh Dilaporkan',
      },
      {
        label_id: 'Tanggal Dicetak',
        label_en: 'Printed Date',
        label_my: 'Tarikh Dicetak',
      },
      {
        label_id: 'List Dokumen',
        label_en: 'Document List',
        label_my: 'Senarai Dokumen',
      },
      {
        label_id: 'Dokumen Kosong',
        label_en: 'Empty Document',
        label_my: 'Dokumen Kosong',
      },
      {
        label_id: 'Perlu diisi!',
        label_en: 'Required!',
        label_my: 'Perlu diisi!',
      },
      {
        label_id: 'Penyakit',
        label_en: 'Disease',
        label_my: 'Penyakit',
      },
      {
        label_id: 'Silakan pilih penyakit dari rekomendasi AI di bawah ini.',
        label_en: 'Please select a disease from the AI recommendations below.',
        label_my: 'Silakan pilih penyakit dari rekomendasi AI di bawah ini.',
      },
      {
        label_id: 'Prosedur',
        label_en: 'Procedure',
        label_my: 'Prosedur',
      },
      {
        label_id: 'Silakan pilih prosedur dari rekomendasi AI di bawah ini.',
        label_en:
          'Please select a procedure from the AI recommendations below.',
        label_my: 'Silakan pilih prosedur dari rekomendasi AI di bawah ini.',
      },
      {
        label_id: 'Diagnosa',
        label_en: 'Diagnosis',
        label_my: 'Diagnosa',
      },
      {
        label_id: 'Lokasi',
        label_en: 'Location',
        label_my: 'Lokasi',
      },
      {
        label_id: 'Hasil Lab',
        label_en: 'Lab Result',
        label_my: 'Hasil Lab',
      },
      {
        label_id: 'Jenis Klaim',
        label_en: 'Claim Type',
        label_my: 'Jenis Klaim',
      },
      {
        label_id: 'Melebihi HET',
        label_en: 'Exceeds HET',
        label_my: 'Melebihi HET',
      },
      {
        label_id: 'Butuh Konfirmasi',
        label_en: 'Needs Confirmation',
        label_my: 'Butuh Konfirmasi',
      },
      {
        label_id: 'Item Butuh Konfirmasi',
        label_en: 'Needs Confirmation Item',
        label_my: 'Item Butuh Konfirmasi',
      },
      {
        label_id: 'Ringkasan Relevansi Medis',
        label_en: 'Medical Relevance Summary',
        label_my: 'Ringkasan Relevansi Medis',
      },
      {
        label_id: 'Bandingkan Riwayat Klaim',
        label_en: 'Compare Claim History',
        label_my: 'Bandingkan Riwayat Klaim',
      },
      {
        label_id: 'Ubah Referensi Invoice',
        label_en: 'Change Invoice Reference',
        label_my: 'Ubah Referensi Invoice',
      },
      {
        label_id: 'Total Riwayat Klaim',
        label_en: 'Total Claim History',
        label_my: 'Jumlah Riwayat Klaim',
      },
      {
        label_id: 'Total Aktual Klaim',
        label_en: 'Total Actual Claim',
        label_my: 'Jumlah Aktual Klaim',
      },
      {
        label_id: 'Selisih Harga',
        label_en: 'Price Difference',
        label_my: 'Selisih Harga',
      },
      {
        label_id: 'Data Kosong',
        label_en: 'Empty Data',
        label_my: 'Data Kosong',
      },
      {
        label_id: 'Manfaat Polis Kategori',
        label_en: 'Category Policy Benefits',
        label_my: 'Faedah Polisi Kategori',
      },
      {
        label_id: 'Lanjutkan ke Proses Monitoring',
        label_en: 'Continue to Monitoring Process',
      },
      {
        label_id:
          'Apakah Anda yakin untuk melanjutkan klaim ke proses monitoring? Silakan periksa kembali informasi kelayakan klaim sebelum melanjutkan ke klaim monitoring.',
        label_en:
          'Are you sure you want to continue the claim to the monitoring process? Please review the claim eligibility information before proceeding to claim monitoring.',
      },
      {
        label_id: 'Lanjutkan Proses',
        label_en: 'Continue Process',
      },
    ],
  },
  {
    page: 'Modal Add/Edit Item Rincian',
    label: [
      {
        label_id: 'Tambah Item',
        label_en: 'Add Item',
        label_my: 'Tambah Item',
      },
      {
        label_id: 'Nama Item',
        label_en: 'Item Name',
        label_my: 'Nama Item',
      },
      {
        label_id: 'Harga',
        label_en: 'Price',
        label_my: 'Harga',
      },
      {
        label_id: 'Batal',
        label_en: 'Cancel',
        label_my: 'Batal',
      },
      {
        label_id: 'Kirim',
        label_en: 'Submit',
        label_my: 'Kirim',
      },
    ],
  },
  {
    page: 'Modal Invoice Reference',
    label: [
      {
        label_id: 'Penyakit',
        label_en: 'Disease',
        label_my: 'Penyakit',
      },
      {
        label_id: 'Prosedur',
        label_en: 'Procedure',
        label_my: 'Prosedur',
      },
      {
        label_id: 'Rumah Sakit',
        label_en: 'Hospital',
        label_my: 'Rumah Sakit',
      },
      {
        label_id: 'Kelas',
        label_en: 'Class',
        label_my: 'Kelas',
      },
      {
        label_id: 'Dokter',
        label_en: 'Doctor',
        label_my: 'Dokter',
      },
      {
        label_id: 'Tanggal',
        label_en: 'Date',
        label_my: 'Tanggal',
      },
      {
        label_id: 'Pilih Tanggal',
        label_en: 'Select Date',
        label_my: 'Pilih Tanggal',
      },
      {
        label_id: 'Total Invoice',
        label_en: 'Total Invoice',
        label_my: 'Jumlah Invoice',
      },
      {
        label_id: 'Harga',
        label_en: 'Price',
        label_my: 'Harga',
      },
      {
        label_id: 'Kecocokan',
        label_en: 'Compatibility',
        label_my: 'Kecocokan',
      },
      {
        label_id: 'Silakan pilih Referensi Klaim',
        label_en: 'Please select Claim Reference',
        label_my: 'Silakan pilih Referensi Klaim',
      },
      {
        label_id: 'Silakan pilih Referensi Invoice untuk Validasi Klaim',
        label_en: 'Please select Invoice Reference for Claim Validation',
        label_my: 'Silakan pilih Referensi Invoice untuk Validasi Klaim',
      },
      {
        label_id:
          'Klaim post-aproval akan dibandingkan dengan referensi klaim yang anda pilih.',
        label_en:
          'Post-approval claims will be compared with the claim reference you selected.',
        label_my:
          'Klaim pasca-aproval akan dibandingkan dengan referensi klaim yang anda pilih.',
      },
      {
        label_id:
          'Sistem Al kami merekomendasikan referensi invoice berdasarkan kesamaan prosedur medis, rumah sakit, dan estimasi harga pasar untuk membantu mendeteksi potensi fraud dan pemborosan',
        label_en:
          'Our AI system recommends invoice references based on similarities in medical procedures, hospitals, and market price estimates to help detect potential fraud and waste.',
      },
      {
        label_id: 'Rentang Tanggal',
        label_en: 'Date Range',
        label_my: 'Rentang Tanggal',
      },
      {
        label_id: 'Rentang Total Biaya',
        label_en: 'Total Cost Range',
        label_my: 'Rentang Total Biaya',
      },
      {
        label_id: 'Pilih Rentang Tanggal',
        label_en: 'Select Date Range',
        label_my: 'Pilih Rentang Tanggal',
      },
      {
        label_id: 'Rumah Sakit, Invoice Name',
        label_en: 'Hospital, Invoice Name',
        label_my: 'Rumah Sakit, Nama Invoice',
      },
      {
        label_id: 'Batal',
        label_en: 'Cancel',
        label_my: 'Batal',
      },
      {
        label_id: 'Konfirmasi Riwayat Klaim',
        label_en: 'Confirm Claim History',
        label_my: 'Konfirmasi Riwayat Klaim',
      },
      {
        label_id: 'Konfirmasi Referensi Invoice',
        label_en: 'Confirm Invoice Reference',
        label_my: 'Konfirmasi Referensi Invoice',
      },
      {
        label_id: 'Skor',
        label_en: 'Score',
      },
    ],
  },
  {
    page: 'Modal Invoice Form',
    label: [
      {
        label_id: 'Mohon Pilih Penyakit!',
        label_en: 'Please Select Disease!',
        label_my: 'Mohon Pilih Penyakit!',
      },
      {
        label_id: 'Mohon Pilih Prosedur!',
        label_en: 'Please Select Procedure!',
        label_my: 'Mohon Pilih Prosedur!',
      },
      {
        label_id: 'Mohon Pilih Rumah Sakit!',
        label_en: 'Please Select Hospital!',
        label_my: 'Mohon Pilih Rumah Sakit!',
      },
      {
        label_id: 'Mohon Pilih Class!',
        label_en: 'Please Select Class!',
        label_my: 'Mohon Pilih Kelas!',
      },
      {
        label_id: 'Konfirmasi Data',
        label_en: 'Confirm Data',
        label_my: 'Konfirmasi Data',
      },
      {
        label_id:
          'Silakan isi data berikut untuk meningkatkan akurasi pembelajaran mesin.',
        label_en:
          'Please fill in the following data to improve machine learning accuracy.',
        label_my:
          'Silakan isi data berikut untuk meningkatkan akurasi pembelajaran mesin.',
      },
      {
        label_id: 'Penyakit',
        label_en: 'Disease',
        label_my: 'Penyakit',
      },
      {
        label_id: 'Pilih',
        label_en: 'Select',
        label_my: 'Pilih',
      },
      {
        label_id: 'Pilih Penyakit',
        label_en: 'Select Disease',
        label_my: 'Pilih Penyakit',
      },
      {
        label_id: 'Prosedur',
        label_en: 'Procedure',
        label_my: 'Prosedur',
      },
      {
        label_id: 'Pilih Prosedur',
        label_en: 'Select Procedure',
        label_my: 'Pilih Prosedur',
      },
      {
        label_id: 'ID Klaim',
        label_en: 'ID Claim',
        label_my: 'ID Klaim',
      },
      {
        label_id: 'No. Tiket',
        label_en: 'No. Ticket',
        label_my: 'No. Tiket',
      },
      {
        label_id: 'Rumah Sakit',
        label_en: 'Hospital',
        label_my: 'Rumah Sakit',
      },
      {
        label_id: 'Pilih Rumah Sakit',
        label_en: 'Select Hospital',
        label_my: 'Pilih Rumah Sakit',
      },
      {
        label_id: 'Kelas',
        label_en: 'Class',
        label_my: 'Kelas',
      },
      {
        label_id: 'Pilih Kelas',
        label_en: 'Select Class',
        label_my: 'Pilih Kelas',
      },
      {
        label_id: 'Dokter',
        label_en: 'Doctor',
        label_my: 'Dokter',
      },
      {
        label_id: 'Wilayah',
        label_en: 'Region',
        label_my: 'Wilayah',
      },
      {
        label_id: 'Batal',
        label_en: 'Cancel',
        label_my: 'Batal',
      },
      {
        label_id: 'Simpan',
        label_en: 'Save',
        label_my: 'Simpan',
      },
      {
        label_id: 'Simpan Filter',
        label_en: 'Save Filter',
        label_my: 'Simpan Filter',
      },
    ],
  },
  {
    page: 'Modal Edit Informasi Pasien',
    label: [
      {
        label_id: 'Edit Informasi Pasien',
        label_en: 'Edit Patient Information',
        label_my: 'Edit Informasi Pesakit',
      },
      {
        label_id: 'Tanggal Lahir',
        label_en: 'Date of Birth',
        label_my: 'Tarikh Lahir',
      },
      {
        label_id: 'Tanggal lahir tidak boleh kosong',
        label_en: 'Date of Birth is required',
        label_my: 'Tarikh Lahir tidak boleh kosong',
      },
      {
        label_id: 'Jenis Kelamin',
        label_en: 'Gender',
        label_my: 'Jantina',
      },
      {
        label_id: 'Pilih Jenis Kelamin',
        label_en: 'Select Gender',
        label_my: 'Pilih Jantina',
      },
      {
        label_id: 'Jenis kelamin tidak boleh kosong',
        label_en: 'Gender is required',
        label_my: 'Jantina tidak boleh kosong',
      },
      {
        label_id: 'Batal',
        label_en: 'Cancel',
        label_my: 'Batal',
      },
      {
        label_id: 'Simpan',
        label_en: 'Save',
        label_my: 'Simpan',
      },
    ],
  },
  {
    page: 'Modal Edit Informasi Asuransi',
    label: [
      {
        label_id: 'Edit Informasi Asuransi',
        label_en: 'Edit Insurance Information',
        label_my: 'Edit Informasi Asuransi',
      },
      {
        label_id: 'Ubah Informasi Asuransi',
        label_en: 'Edit Insurance Information',
        label_my: 'Edit Informasi Asuransi',
      },
      {
        label_id: 'Penyedia Asuransi',
        label_en: 'Insurance Provider',
        label_my: 'Penyedia Asuransi',
      },
      {
        label_id: 'Jenis Asuransi',
        label_en: 'Insurance Type',
        label_my: 'Jenis Asuransi',
      },
      {
        label_id: 'Penyedia asuransi tidak boleh kosong',
        label_en: 'Insurance Provider is required',
        label_my: 'Penyedia Asuransi tidak boleh kosong',
      },
      {
        label_id: 'Nomor Polis',
        label_en: 'Policy Number',
        label_my: 'Nomor Polis',
      },
      {
        label_id: 'Nomor polis harus diisi',
        label_en: 'Policy Number is required',
        label_my: 'Nomor polis harus diisi',
      },
      {
        label_id: 'Nomor Tiket',
        label_en: 'Ticket Number',
        label_my: 'Nomor Tiket',
      },
      {
        label_id: 'Nomor tiket harus diisi',
        label_en: 'Ticket Number is required',
        label_my: 'Nomor tiket harus diisi',
      },
      {
        label_id: 'Nomor Member',
        label_en: 'Member Number',
        label_my: 'Nomor Member',
      },
      {
        label_id: 'Wajib Diisi untuk group health',
        label_en: 'Member Number is required for group health',
        label_my: 'Nomor Member wajib diisi untuk group health',
      },
      // {
      //   label_id: 'Verifikasi',
      //   label_en: 'Verification',
      //   label_my: 'Verifikasi',
      // },
      {
        label_id: 'Verifikasi',
        label_en: 'Verify',
        label_my: 'Verifikasi',
      },
      {
        label_id: 'Nomor polis tidak boleh kosong',
        label_en: 'Policy Number is required',
        label_my: 'Nomor Polis tidak boleh kosong',
      },
      {
        label_id: 'Nomor Indeks',
        label_en: 'Index Number',
        label_my: 'Nomor Indeks',
      },
      {
        label_id: 'Jenis Asuransi',
        label_en: 'Insurance Type',
        label_my: 'Jenis Asuransi',
      },
      {
        label_id: 'Jenis asuransi tidak boleh kosong',
        label_en: 'Insurance Type is required',
        label_my: 'Jenis Asuransi tidak boleh kosong',
      },
      {
        label_id: 'Kategori Klaim',
        label_en: 'Claim Category',
        label_my: 'Kategori Klaim',
      },
      {
        label_id: 'Nama Analis',
        label_en: 'Analyst Name',
        label_my: 'Nama Analis',
      },
      {
        label_id: 'Kelas',
        label_en: 'Class',
        label_my: 'Kelas',
      },
      {
        label_id: 'Kelas tidak boleh kosong',
        label_en: 'Class is required',
        label_my: 'Kelas tidak boleh kosong',
      },
      {
        label_id: 'Admission Type',
        label_en: 'Admission Type',
        label_my: 'Admission Type',
      },
      {
        label_id: 'Admission type tidak boleh kosong',
        label_en: 'Admission Type is required',
        label_my: 'Admission Type tidak boleh kosong',
      },
      {
        label_id: 'Batal',
        label_en: 'Cancel',
        label_my: 'Batal',
      },
      {
        label_id: 'Simpan',
        label_en: 'Save',
        label_my: 'Simpan',
      },
    ],
  },
  {
    page: 'Modal Edit Informasi Klaim',
    label: [
      {
        label_id: 'Edit Informasi Klaim',
        label_en: 'Edit Claim Information',
        label_my: 'Edit Informasi Klaim',
      },
      {
        label_id: 'Ubah Informasi Klaim',
        label_en: 'Edit Claim Information',
        label_my: 'Ubah Informasi Klaim',
      },
      {
        label_id: 'Jenis Transaksi Klaim',
        label_en: 'Claim Transaction Type',
        label_my: 'Jenis Transaksi Klaim',
      },
      {
        label_id: 'Tanggal Terima Claim',
        label_en: 'Claim Receipt Date',
        label_my: 'Tanggal Terima Claim',
      },
      {
        label_id: 'Bentuk Berkas',
        label_en: 'Claim File Format',
        label_my: 'Bentuk Berkas',
      },
      {
        label_id: 'No. REF dari GAF',
        label_en: 'No. REF from GAF',
        label_my: 'No. REF dari GAF',
      },
      {
        label_id: 'Jenis Klaim',
        label_en: 'Claim Type',
        label_my: 'Jenis Klaim',
      },
      {
        label_id: 'Prioritas',
        label_en: 'Priority',
        label_my: 'Prioritas',
      },
      {
        label_id: 'Jenis Transaksi',
        label_en: 'Transaction Type',
        label_my: 'Jenis Transaksi',
      },
      {
        label_id: 'Mata Uang',
        label_en: 'Currency',
        label_my: 'Mata Uang',
      },
      {
        label_id: 'Jumlah Transaksi',
        label_en: 'Transaction Amount',
        label_my: 'Jumlah Transaksi',
      },
      {
        label_id: 'Catatan',
        label_en: 'Notes',
        label_my: 'Catatan',
      },
      {
        label_id: 'Batal',
        label_en: 'Cancel',
        label_my: 'Batal',
      },
      {
        label_id: 'Simpan',
        label_en: 'Save',
        label_my: 'Simpan',
      },
    ],
  },
  {
    page: 'Modal Edit Informasi Reimbursement',
    label: [
      {
        label_id: 'Edit Informasi Surat Jaminan',
        label_en: 'Edit Guarantee Letter Information',
        label_my: 'Edit Informasi Surat Jaminan',
      },
      {
        label_id: 'Ubah Informasi Surat Jaminan',
        label_en: 'Edit Guarantee Letter Information',
        label_my: 'Ubah Informasi Surat Jaminan',
      },
      {
        label_id: 'Ubah Informasi Surat Jaminan & Reimbursment',
        label_en: 'Edit Guarantee Letter & Reimbursement Information',
        label_my: 'Ubah Informasi Surat Jaminan & Reimbursment',
      },
      {
        label_id: 'Reimbursment',
        label_en: 'Reimbursement',
        label_my: 'Reimbursment',
      },
      {
        label_id: 'No surat Jamninan (jika rawat inap jaminan CAR)',
        label_en: 'No Guarantee Letter (if inpatient guarantee CAR)',
        label_my: 'No surat Jamninan (jika rawat inap jaminan CAR)',
      },
      {
        label_id: 'No Surat Jaminan (jika rawat inap jaminan CAR)',
        label_en: 'Guarantee Letter No. (if inpatient guarantee CAR)',
        label_my: 'No Surat Jaminan (jika rawat inap jaminan CAR)',
      },
      {
        label_id: 'No Surat Jaminan',
        label_en: 'Guarantee Letter No.',
        label_my: 'No Surat Jaminan',
      },
      {
        label_id: 'Tanggal Surat Jaminan',
        label_en: 'Guarantee Letter Date',
        label_my: 'Tanggal Surat Jaminan',
      },
      {
        label_id: 'Tanggal Terima Klaim',
        label_en: 'Claim Receipt Date',
        label_my: 'Tanggal Terima Klaim',
      },
      {
        label_id: 'No surat PP (Reimbursment)',
        label_en: 'Reimbursement Letter No.',
        label_my: 'No surat PP (Reimbursment)',
      },
      {
        label_id: 'No surat PP',
        label_en: 'Reimbursement Letter No.',
        label_my: 'No Surat PP',
      },
      {
        label_id: 'Tanggal surat PP (Reimbursment)',
        label_en: 'Reimbursement Letter Date',
        label_my: 'Tanggal surat PP (Reimbursment)',
      },
      {
        label_id: 'Tanggal Terima Klaim',
        label_en: 'Claim Receipt Date',
        label_my: 'Tanggal Terima Klaim',
      },
      {
        label_id: 'Batal',
        label_en: 'Cancel',
        label_my: 'Batal',
      },
      {
        label_id: 'Simpan',
        label_en: 'Save',
        label_my: 'Simpan',
      },
    ],
  },
  {
    page: 'Modal Edit Informasi Rs',
    label: [
      {
        label_id: 'Edit Informasi Rumah Sakit',
        label_en: 'Edit Hospital Information',
        label_my: 'Edit Informasi Rumah Sakit',
      },
      {
        label_id: 'Ubah Informasi Rumah Sakit',
        label_en: 'Edit Hospital Information',
        label_my: 'Ubah Informasi Rumah Sakit',
      },
      {
        label_id: 'Nama Rumah Sakit',
        label_en: 'Hospital Name',
        label_my: 'Nama Rumah Sakit',
      },
      {
        label_id: 'Nama rumah sakit tidak boleh kosong',
        label_en: 'Hospital Name is required',
        label_my: 'Nama Rumah Sakit tidak boleh kosong',
      },
      {
        label_id: 'Email tidak boleh kosong',
        label_en: 'Email is required',
        label_my: 'Email tidak boleh kosong',
      },
      {
        label_id: 'Dokter',
        label_en: 'Doctor',
        label_my: 'Dokter',
      },
      {
        label_id: 'Wilayah',
        label_en: 'Region',
        label_my: 'Wilayah',
      },
      {
        label_id: 'Alamat',
        label_en: 'Address',
        label_my: 'Alamat',
      },
      {
        label_id: 'Alamat tidak boleh kosong',
        label_en: 'Address is required',
        label_my: 'Alamat tidak boleh kosong',
      },
      {
        label_id: 'Batal',
        label_en: 'Cancel',
        label_my: 'Batal',
      },
      {
        label_id: 'Simpan',
        label_en: 'Save',
        label_my: 'Simpan',
      },
    ],
  },
  {
    page: 'Modal Edit Informasi Diagnosa',
    label: [
      {
        label_id: 'Edit Informasi Diagnosis',
        label_en: 'Edit Diagnosis Information',
        label_my: 'Edit Informasi Diagnosis',
      },
      {
        label_id: 'Ubah Informasi Diagnosis',
        label_en: 'Edit Diagnosis Information',
        label_my: 'Ubah Informasi Diagnosis',
      },
      {
        label_id: 'Penyakit',
        label_en: 'Disease',
        label_my: 'Penyakit',
      },
      {
        label_id: 'Klasifikasi Penyakit',
        label_en: 'Disease Classification',
        label_my: 'Klasifikasi Penyakit',
      },
      {
        label_id: 'Diagnosis',
        label_en: 'Diagnosis',
        label_my: 'Diagnosis',
      },
      {
        label_id: 'Prosedur',
        label_en: 'Procedure',
        label_my: 'Prosedur',
      },
      {
        label_id: 'Pilih Prosedur',
        label_en: 'Select Procedure',
        label_my: 'Pilih Prosedur',
      },
      {
        label_id: 'Batal',
        label_en: 'Cancel',
        label_my: 'Batal',
      },
      {
        label_id: 'Simpan',
        label_en: 'Save',
        label_my: 'Simpan',
      },
      {
        label_id: 'Catatan Pulang',
        label_en: 'Discharge Notes',
      },
    ],
  },
  {
    page: 'Modal Edit Informasi Lab',
    label: [
      {
        label_id: 'Edit Informasi Laboratorium',
        label_en: 'Edit Laboratory Information',
        label_my: 'Edit Informasi Laboratorium',
      },
      {
        label_id: 'Ubah Informasi Laboratorium',
        label_en: 'Edit Laboratory Information',
        label_my: 'Ubah Informasi Laboratorium',
      },
      {
        label_id: 'Edit Hasil Diagnostik & Laboratorium',
        label_en: 'Edit Diagnostic & Laboratory Results',
        label_my: 'Edit Hasil Diagnostik & Laboratorium',
      },
      {
        label_id: 'Lokasi',
        label_en: 'Location',
        label_my: 'Lokasi',
      },
      {
        label_id: 'Lokasi pasien tidak boleh kosong',
        label_en: 'Location is required',
        label_my: 'Lokasi pasien tidak boleh kosong',
      },
      {
        label_id: 'Klinisi',
        label_en: 'Clinician',
        label_my: 'Klinisi',
      },
      {
        label_id: 'Klinisi ktp tidak boleh kosong',
        label_en: 'Clinician ID is required',
        label_my: 'Klinisi ktp tidak boleh kosong',
      },
      {
        label_id: 'Nomor Lab',
        label_en: 'Lab Number',
        label_my: 'Nomor Lab',
      },
      {
        label_id: 'Nomor Lab tidak boleh kosong',
        label_en: 'Lab Number is required',
        label_my: 'Nomor Lab tidak boleh kosong',
      },
      {
        label_id: 'Tanggal Dipesan',
        label_en: 'Order Date',
        label_my: 'Tanggal Dipesan',
      },
      {
        label_id: 'Tanggal dipesan tidak boleh kosong',
        label_en: 'Order Date is required',
        label_my: 'Tanggal dipesan tidak boleh kosong',
      },
      {
        label_id: 'Tanggal Dilaporkan',
        label_en: 'Reported Date',
        label_my: 'Tanggal Dilaporkan',
      },
      {
        label_id: 'Tanggal dilaporkan tidak boleh kosong',
        label_en: 'Reported Date is required',
        label_my: 'Tanggal dilaporkan tidak boleh kosong',
      },
      {
        label_id: 'Tanggal Dicetak',
        label_en: 'Printed Date',
        label_my: 'Tanggal Dicetak',
      },
      {
        label_id: 'Tanggal dicetak tidak boleh kosong',
        label_en: 'Printed Date is required',
        label_my: 'Tanggal dicetak tidak boleh kosong',
      },
      {
        label_id: 'Hasil Lab',
        label_en: 'Lab Result',
        label_my: 'Hasil Lab',
      },
      {
        label_id: 'Tulis Hasil Lab disini',
        label_en: 'Write Lab Result here',
        label_my: 'Tulis Hasil Lab disini',
      },
      {
        label_id: 'Hasil lab tidak boleh kosong',
        label_en: 'Lab Result is required',
        label_my: 'Hasil lab tidak boleh kosong',
      },
      {
        label_id: 'Batal',
        label_en: 'Cancel',
        label_my: 'Batal',
      },
      {
        label_id: 'Simpan',
        label_en: 'Save',
        label_my: 'Simpan',
      },
      {
        label_id: 'Tambah Hasil Lab',
        label_en: 'Add Lab Result',
      },
      {
        label_id: 'Ubah Hasil Lab',
        label_en: 'Edit Lab Result',
      },
    ],
  },
  {
    page: 'Loading Cashless',
    label: [
      {
        label_id: 'AI sedang memproses dokumen',
        label_en: 'AI is processing the document',
        label_my: 'AI sedang memproses dokumen',
      },
      {
        label_id: 'Validasi Tag',
        label_en: 'Validate Tag',
        label_my: 'Validasi Tag',
      },
      {
        label_id:
          'Memeriksa apakah tag atau label pada data klaim sesuai dengan standar sistem.',
        label_en:
          'Check if the tags or labels on the claim data comply with system standards.',
        label_my:
          'Memeriksa apakah tag atau label pada data klaim sesuai dengan standar sistem.',
      },
      {
        label_id: 'Validasi Dokumen',
        label_en: 'Document Validation',
        label_my: 'Validasi Dokumen',
      },
      {
        label_id: 'Validasi Informasi',
        label_en: 'Information Validation',
        label_my: 'Validasi Informasi',
      },
      {
        label_id:
          'Memastikan dokumen yang diunggah lengkap, terbaca, dan sesuai format yang dibutuhkan.',
        label_en:
          'Ensure that the uploaded documents are complete, readable, and in the required format.',
        label_my:
          'Memastikan dokumen yang diunggah lengkap, terbaca, dan sesuai format yang dibutuhkan.',
      },
      {
        label_id:
          'Membaca dan memvalidasi informasi konten dari dokumen klaim.',
        label_en:
          'Reading and validating the content information from the claim documents.',
        label_my:
          'Membaca dan memvalidasi informasi konten dari dokumen klaim.',
      },
      {
        label_id: 'Menganalisa Keaktifan Polis',
        label_en: 'Analyzing Policy Activity',
        label_my: 'Menganalisa Keaktifan Polis',
      },
      {
        label_id:
          'Menganalisa kesesuaian polis dengan data informasi pada dokumen klaim.',
        label_en:
          'Analyzing Policy Compliance with Claim Document Information.',
        label_my:
          'Menganalisa kesesuaian polis dengan data informasi pada dokumen klaim.',
      },
      {
        label_id: 'Memeriksa Kelayakan klaim',
        label_en: 'Checking Claim Eligibility',
        label_my: 'Memeriksa Kelayakan klaim',
      },
      {
        label_id:
          'Memeriksa apakah klaim layak berdasarkan informasi pada dokumen.',
        label_en: 'Checking Claim Eligibility based on document information.',
        label_my:
          'Memeriksa apakah klaim layak berdasarkan informasi pada dokumen.',
      },
      {
        label_id: 'AI Sedang melakukan pengecekan detail keaktifan polis.',
        label_en: 'AI is checking the details of policy activity.',
        label_my: 'AI sedang melakukan pengecekan detail keaktifan polis.',
      },
      {
        label_id: 'Menganalisa Dokumen',
        label_en: 'Document Analysis',
        label_my: 'Analisis Dokumen',
      },
      {
        label_id:
          'AI mengekstraksi dan menganalisis informasi penting dari dokumen klaim.',
        label_en:
          'AI extracts and analyzes critical information from claim documents.',
        label_my:
          'AI mengekstraksi dan menganalisis informasi penting dari dokumen klaim.',
      },
      {
        label_id:
          'AI mengekstraksi dan menganalisa informasi penting dari dokumen klaim.',
        label_en:
          'AI extracts and analyzes important information from the claim documents.',
        label_my:
          'AI mengekstraksi dan menganalisa informasi penting dari dokumen klaim.',
      },
      {
        label_id:
          'Langkah ini membutuhkan waktu lebih lama dari yang lain. Mohon menunggu sejenak.',
        label_en:
          'This step takes longer than the others. Please wait a moment.',
        label_my:
          'Langkah ini membutuhkan waktu lebih lama dari yang lain. Mohon menunggu sejenak.',
      },
      {
        label_id: 'Memverifikasi data klaim dengan sistem',
        label_en: 'Verifying claim data with the system',
        label_my: 'Memverifikasi data klaim dengan sistem',
      },
      {
        label_id: 'Mencocokkan dengan Relevansi Medis',
        label_en: 'Matching with Medical Relevance',
        label_my: 'Mencocokkan dengan Relevansi Medis',
      },
      {
        label_id: 'Memeriksa Data Enrollment',
        label_en: 'Verifying Enrollment Data',
        label_my: 'Memverifikasi Data Enrollment',
      },
      {
        label_id: 'Menghubungkan data klaim dengan data enrollment',
        label_en: 'Connecting claim data with enrollment data',
        label_my: 'Menghubungkan data klaim dengan data enrollment',
      },
      {
        label_id:
          'Membandingkan data klaim dengan informasi sistem untuk diverifikasi.',
        label_en:
          'Comparing claim data with system information for verification.',
        label_my:
          'Membandingkan data klaim dengan informasi sistem untuk diverifikasi.',
      },
      {
        label_id: 'Mencocokan dengan Relevansi Medis',
        label_en: 'Matching with Medical Relevance',
        label_my: 'Mencocokan dengan Relevansi Medis',
      },
      {
        label_id:
          'Memverifikasi apakah diagnosis dan tindakan medis sesuai dengan pedoman klinis.',
        label_en:
          'Verifying whether the diagnosis and medical actions comply with clinical guidelines.',
        label_my:
          'Memverifikasi apakah diagnosis dan tindakan medis sesuai dengan pedoman klinis.',
      },
      {
        label_id: 'Membuat Coverage Approval',
        label_en: 'Creating Coverage Approval',
        label_my: 'Membuat Persetujuan Cakupan',
      },
      {
        label_id:
          'Mengecek kesesuaian klaim dengan ketentuan polis dan menghasilkan persetujuan manfaat.',
        label_en:
          'Checking claim compliance with policy provisions and generating benefit approvals.',
        label_my:
          'Mengecek kesesuaian klaim dengan ketentuan polis dan menghasilkan persetujuan manfaat.',
      },
      {
        label_id: 'Menggenerate Kesimpulan',
        label_en: 'Generating Conclusion',
        label_my: 'Menggenerate Kesimpulan',
      },
      {
        label_id:
          'Menyusun ringkasan hasil evaluasi klaim untuk pengambilan keputusan akhir.',
        label_en:
          'Summarizing the claim evaluation results for final decision-making.',
        label_my:
          'Menyusun ringkasan hasil evaluasi klaim untuk pengambilan keputusan akhir.',
      },
    ],
  },
  {
    page: 'DetailClaimOutpatient',
    label: [
      {
        label_id: 'Dokumen',
        label_en: 'Document',
      },
      {
        label_id: 'Kembali ke list',
        label_en: 'Back to list',
      },
      {
        label_id: 'dari',
        label_en: 'of',
      },
      {
        label_id: 'Halaman',
        label_en: 'Page',
      },
      {
        label_id: 'Catatan',
        label_en: 'Note',
      },
      {
        label_id: 'Obat Pemberian Pulang',
        label_en: 'Take-Home Medication',
      },
      {
        label_id: 'Obat Pemberian Langsung',
        label_en: 'On-Site Medication',
      },
      {
        label_id: 'Nama Item',
        label_en: 'Item Name',
      },
      {
        label_id: 'Durasi',
        label_en: 'Duration',
      },
      {
        label_id: 'Dosis dan Frekuensi',
        label_en: 'Dosage and Frequency',
      },
      {
        label_id: 'Rute',
        label_en: 'Route',
      },
      {
        label_id: 'Log Versi',
        label_en: 'Version Log',
      },
      {
        label_id: 'Ekstrak Data',
        label_en: 'Extract Data',
      },
      {
        label_id: 'Kirim ke Analis',
        label_en: 'Send to Analyst',
      },
      {
        label_id: 'Ajukan Persetujuan',
        label_en: 'Submit Approval',
      },
      {
        label_id: 'Setujui Klaim',
        label_en: 'Approve Claim',
      },
      {
        label_id: 'Tolak Klaim',
        label_en: 'Reject Claim',
      },
      {
        label_id: 'Aktifkan Klaim',
        label_en: 'Activate Claim',
      },
      {
        label_id:
          'Anda yakin untuk mengaktifkan proses klaim? Status klaim akan aktif kembali setelah dilanjutkan.',
        label_en:
          'Are you sure you want to activate the claim process? The claim status will be reactivated once continued.',
      },
      {
        label_id: 'Pending Klaim',
        label_en: 'Pending Claim',
      },
      {
        label_id:
          'Apakah Anda yakin ingin menunda klaim? Klaim akan dinonaktifkan sementara hingga statusnya kembali aktif.',
        label_en:
          'Are you sure you want to suspend the claim? The claim will be temporarily disabled until its status is reactivated.',
      },
      {
        label_id: 'Perbandingan Klaim',
        label_en: 'Compare Claim',
      },
      {
        label_id: 'Kirim ke Core System',
        label_en: 'Send to Core System',
      },
      {
        label_id: 'Penerima Berikutnya',
        label_en: 'Next Approver',
      },
      {
        label_id: 'Alasan Persetujuan',
        label_en: 'Approval Reason',
      },
      {
        label_id: 'Alasan Penolakan',
        label_en: 'Rejection Reason',
      },
      {
        label_id: 'Tulis alasan di sini...',
        label_en: 'Write reason here...',
      },
      {
        label_id: 'Apakah anda yakin untuk menyetujui klaim?',
        label_en: 'Are you sure you want to approve the claim?',
      },
      {
        label_id: 'Apakah anda yakin untuk menolak klaim?',
        label_en: 'Are you sure you want to reject the claim?',
      },
      {
        label_id: 'Konfirmasi Buku Tarif dan Referensi Invoice',
        label_en: 'Confirm Tariff Book and Invoice Reference',
      },
      {
        label_id:
          'Konfirmasi Buku Tarif untuk menggunakan Fraud Detection dan Referensi Invoice untuk membandingkan Riwayat Klaim',
        label_en:
          'Confirm Tariff Book to use Fraud Detection and Invoice Reference to compare Claim History',
      },
      {
        label_id:
          'Klaim akan dikirim ke Supervisor untuk dilakukan persetujuan. Silahkan tinjau klaim kembali sebelum mengkonfirmasi pengajuan persetujuan.',
        label_en:
          'The claim will be sent to the Supervisor for approval. Please review the claim before confirming the approval request.',
      },
      {
        label_id: 'Konfirmasi Buku Tarif',
        label_en: 'Confirm Tariff Book',
      },
      {
        label_id: 'Konfirmasi Riwayat Klaim',
        label_en: 'Confirm Claim History',
      },
      {
        label_id: 'Konfirmasi Relevansi Medis',
        label_en: 'Confirm Medical Relevance',
      },
      {
        label_id: 'Ajukan Persetujuan Berhasil',
        label_en: 'Submit Approval Successfully',
      },
      {
        label_id: 'Setujui Persetujuan Berhasil',
        label_en: 'Approve Approval Successfully',
      },
      {
        label_id: 'Tolak Persetujuan Berhasil',
        label_en: 'Reject Approval Successfully',
      },
      {
        label_id: 'Tanggal Permintaan',
        label_en: 'Request Date',
      },
      {
        label_id: 'Pembayar Klaim',
        label_en: 'Claim Payer',
      },
      {
        label_id: 'Kategori Klaim',
        label_en: 'Claim Category',
      },
      {
        label_id: 'Tipe Klaim',
        label_en: 'Claim Type',
      },
      {
        label_id: 'Ringkasan Klaim',
        label_en: 'Claim Summary',
      },
      {
        label_id: 'Informasi Pasien',
        label_en: 'Patient Information',
      },
      {
        label_id: 'Ubah',
        label_en: 'Edit',
      },
      {
        label_id: 'Tanggal Lahir',
        label_en: 'Date of Birth',
      },
      {
        label_id: 'Jenis Kelamin',
        label_en: 'Gender',
      },
      {
        label_id: 'Informasi Asuransi',
        label_en: 'Insurance Information',
      },
      {
        label_id: 'Penyedia Asuransi',
        label_en: 'Insurance Provider',
      },
      {
        label_id: 'Nomor Polis',
        label_en: 'Policy Number',
      },
      {
        label_id: 'Nomor Indeks',
        label_en: 'Index Number',
      },
      {
        label_id: 'Jenis Asuransi',
        label_en: 'Insurance Type',
      },
      {
        label_id: 'Nama AnTanggal Penerimaan Klaimalis',
        label_en: 'Analyst Name',
      },
      {
        label_id: 'Kelas',
        label_en: 'Class',
      },
      {
        label_id: 'Jenis Admisi',
        label_en: 'Admission Type',
      },
      {
        label_id: 'Informasi Klaim',
        label_en: 'Claim Information',
      },
      {
        label_id: 'Jenis Transaksi Klaim',
        label_en: 'Claim Transaction Type',
      },
      {
        label_id: 'Tanggal Terima Klaim',
        label_en: 'Claim Receipt Date',
      },
      {
        label_id: 'Bentuk Berkas',
        label_en: 'File Format',
      },
      {
        label_id: 'No. REF dari GAF',
        label_en: 'REF No. from GAF',
      },
      {
        label_id: 'Jenis Klaim',
        label_en: 'Claim Type',
      },
      {
        label_id: 'Prioritas',
        label_en: 'Priority',
      },
      {
        label_id: 'Jenis Transaksi',
        label_en: 'Transaction Type',
      },
      {
        label_id: 'Mata Uang',
        label_en: 'Currency',
      },
      {
        label_id: 'Jumlah Transaksi',
        label_en: 'Transaction Amount',
      },
      {
        label_id: 'Catatan',
        label_en: 'Notes',
      },
      {
        label_id: 'Informasi Surat Jaminan & Reimbursement',
        label_en: 'Guarantee Letter & Reimbursement Information',
      },
      {
        label_id: 'No surat Jaminan',
        label_en: 'Guarantee Letter Number',
      },
      {
        label_id: 'Tanggal Surat Jaminan',
        label_en: 'Claim Receipt Date',
      },
      {
        label_id: 'No surat PP (Reimbursement)',
        label_en: 'Reimbursement Letter Number',
      },
      {
        label_id: 'Tanggal surat PP (Reimbursement)',
        label_en: 'Reimbursement Letter Date',
      },
      {
        label_id: 'Informasi Rumah Sakit',
        label_en: 'Hospital Information',
      },
      {
        label_id: 'Nama Rumah Sakit',
        label_en: 'Hospital Name',
      },
      {
        label_id: 'Email',
        label_en: 'Email',
      },
      {
        label_id: 'Dokter',
        label_en: 'Doctor',
      },
      {
        label_id: 'Wilayah',
        label_en: 'Region',
      },
      {
        label_id: 'Alamat',
        label_en: 'Address',
      },
      {
        label_id: 'Nominal Tagihan',
        label_en: 'Bill Amount',
      },
      {
        label_id: 'Informasi Laboratorium',
        label_en: 'Laboratory Information',
      },
      {
        label_id: 'Lokasi',
        label_en: 'Location',
      },
      {
        label_id: 'Klinisi',
        label_en: 'Clinician',
      },
      {
        label_id: 'Nomor Lab',
        label_en: 'Lab Number',
      },
      {
        label_id: 'Tanggal Dipesan',
        label_en: 'Order Date',
      },
      {
        label_id: 'Tanggal Dilaporkan',
        label_en: 'Report Date',
      },
      {
        label_id: 'Tanggal Dicetak',
        label_en: 'Printed Date',
      },
      {
        label_id: 'Hasil Lab',
        label_en: 'Lab Result',
      },
      {
        label_id: 'Rincian Invoice',
        label_en: 'Invoice Details',
      },
      {
        label_id: 'Bandingkan MIMS',
        label_en: 'Compare MIMS',
      },
      {
        label_id: 'Bandingkan Buku Tarif',
        label_en: 'Compare Tariff Book',
      },
      {
        label_id: 'Bandingkan Riwayat Klaim',
        label_en: 'Compare Claim History',
      },
      {
        label_id: 'Relevansi Medis',
        label_en: 'Medical Relevance',
      },
      {
        label_id: 'Tambah Item',
        label_en: 'Add Item',
      },
      {
        label_id: 'Tambah Kategori',
        label_en: 'Add Category',
      },
      {
        label_id: 'Ubah Kategori',
        label_en: 'Edit Category',
      },
      {
        label_id: 'Hapus Kategori',
        label_en: 'Delete Category',
      },
      {
        label_id: 'Hapus Item',
        label_en: 'Delete Item',
      },
      {
        label_id: 'Informasi Item',
        label_en: 'Item Information',
      },
      {
        label_id: 'Alasan AI',
        label_en: 'AI Reason',
      },
      {
        label_id: 'Alasan AI',
        label_en: 'AI Reason',
      },
      {
        label_id: 'Konversi',
        label_en: 'Conversion',
      },
      {
        label_id: 'Konversi Kurs',
        label_en: 'Currency Conversion',
      },
      {
        label_id: 'Anda yakin untuk menghapus kategori?',
        label_en: 'Are you sure you want to delete the category?',
      },
      {
        label_id:
          'Kategori ini tidak dapat dihapus karena masih ada item yang terkait di dalamnya.',
        label_en:
          'This category cannot be deleted because there are still items associated with it.',
      },
      {
        label_id:
          'Apakah Anda yakin ingin menghapus item ini? Item terkait akan dihapus dari rincian invoice dan FWA (HET, Buku Tarif, Relevansi Medis) dan tidak bisa dipulihkan kembali.',
        label_en:
          'Are you sure you want to delete this item? The item will be removed from the invoice details and FWA (HET, Tariff Book, Medical Relevance) and cannot be restored.',
      },
      {
        label_id:
          'Anda yakin untuk menghapus kategori? Item yang di dalam kategori juga akan terhapus dan tidak dapat dipulihkan kembali.',
        label_en:
          'Are you sure you want to delete the category? Items within the category will also be deleted and cannot be recovered.',
      },
      {
        label_id: 'Tambah Kategori Item',
        label_en: 'Add Category Item',
      },
      {
        label_id: 'Tambah Kategori Manfaat',
        label_en: 'Add Category Benefit',
      },
      {
        label_id: 'Batal',
        label_en: 'Cancel',
      },
      {
        label_id: 'Simpan',
        label_en: 'Save',
      },
      {
        label_id: 'Ringkasan Invoice',
        label_en: 'Invoice Summary',
      },
      {
        label_id: 'Tagihan Akhir',
        label_en: 'Final Invoice',
      },
      {
        label_id: 'Tagihan Sementara',
        label_en: 'Provisional Invoice',
      },
      {
        label_id: 'Tagihan Perkiraan',
        label_en: 'Estimated Invoice',
      },
      {
        label_id: 'Ringkasan Bandingkan Riwayat Klaim',
        label_en: 'Claim History Comparison Summary',
      },
      {
        label_id: 'Ubah Buku Tarif',
        label_en: 'Edit Tariff Book',
      },
      {
        label_id: 'Detail Buku Tarif',
        label_en: 'Tariff Book Details',
      },
      {
        label_id: 'Ringkasan Buku Tarif',
        label_en: 'Tariff Book Summary',
      },
      {
        label_id: 'Ubah Referensi',
        label_en: 'Change Reference',
      },
      {
        label_id: 'Data Kosong',
        label_en: 'No Data',
      },
      {
        label_id: 'Total Riwayat Klaim',
        label_en: 'Total Claim History',
      },
      {
        label_id: 'Total Aktual Klaim',
        label_en: 'Total Actual Claim',
      },
      {
        label_id: 'Selisih Harga',
        label_en: 'Price Difference',
      },
      {
        label_id: 'Ringkasan Riwayat Klaim',
        label_en: 'Claim History Summary',
      },
      {
        label_id: 'Tidak Dicover',
        label_en: 'Not Covered',
      },
      {
        label_id: 'Ringkasan MIMS',
        label_en: 'MIMS Summary',
      },
      {
        label_id: 'Item Butuh Konfirmasi',
        label_en: 'Item Needs Confirmation',
      },
      {
        label_id: 'Item Disetujui',
        label_en: 'Item Approved',
      },
      {
        label_id: 'Item Ditolak',
        label_en: 'Item Rejected',
      },
      {
        label_id: 'Item Butuh Konfirmasi Kosong',
        label_en: 'Item Needs Confirmation Empty',
      },
      {
        label_id: 'Item Disetujui Kosong',
        label_en: 'Item Approved Empty',
      },
      {
        label_id: 'Item Ditolak Kosong',
        label_en: 'Item Rejected Empty',
      },
      {
        label_id: 'Tidak ada item yang Butuh Konfirmasi',
        label_en: 'No Item Needs Confirmation',
      },
      {
        label_id: 'Tidak ada item yang Disetujui',
        label_en: 'No Item Approved',
      },
      {
        label_id: 'Tidak ada item yang Ditolak',
        label_en: 'No Item Rejected',
      },
      {
        label_id: 'Ringkasan Relevansi Medis',
        label_en: 'Medical Relevance Summary',
      },
      {
        label_id: 'Daftar Dokumen',
        label_en: 'Document List',
      },
      {
        label_id: 'Daftar Dokumen Kosong',
        label_en: 'Document List Empty',
      },
      {
        label_id: 'Ajukan Klaim',
        label_en: 'Apply Claim',
      },
      {
        label_id:
          'Klik kolom 2 kali untuk mengedit, dan tekan enter untuk simpan.',
        label_en: 'Double click the column to edit, and press enter to save.',
      },
      {
        label_id:
          'Klik kolom 2 kali untuk mengubah, dan tekan enter untuk simpan.',
        label_en: 'Double click the column to edit, and press enter to save.',
      },
      {
        label_id:
          'Kepercayaan AI saat ini di bawah 80%. Mohon periksa kembali klaim yang ada di tabel invoice dan edit invoice jika terdapat kesalahan.',
        label_en:
          'AI confidence is currently below 80%. Please re-check the claims in the invoice table and edit the invoice if there are any errors.',
      },
      {
        label_id:
          'Apakah Anda yakin ingin mengajukan klaim asuransi? Mohon periksa kembali data sebelum mengajukan asuransi.',
        label_en:
          'Are you sure to apply claim insurance? Please re-check the data before apply the insurance.',
      },
      {
        label_id:
          'Apakah Anda yakin ingin mengirim data klaim asuransi ke sistem inti?',
        label_en: 'Are you sure to send insurance claim data to core system?',
      },
      // Section Coverage Approval
      {
        label_id: 'Coverage Approval',
        label_en: 'Coverage Approval',
      },
      {
        label_id: 'Ditanggung sepenuhnya',
        label_en: 'Fully Covered',
      },
      {
        label_id: 'Ditanggung sebagian',
        label_en: 'Partially Covered',
      },
      {
        label_id: 'Tidak Ditanggung',
        label_en: 'Not Covered',
      },
      {
        label_id: 'Dokumen Polis Tidak Ditemukan',
        label_en: 'Policy Document Not Found',
      },
      {
        label_id: 'Analisis Coverage',
        label_en: 'Coverage Analysis',
      },
      {
        label_id: 'Analisis AI',
        label_en: 'AI Analysis',
      },
      {
        label_id: 'Analis',
        label_en: 'Analyst',
      },
      {
        label_id: 'Polis',
        label_en: 'Policy',
      },
      {
        label_id: 'Lihat Polis',
        label_en: 'View Policy',
      },
      {
        label_id: 'Produk/Plan',
        label_en: 'Product/Plan',
      },
      {
        label_id: 'Mulai Pertanggungan',
        label_en: 'Start Coverage',
      },
      {
        label_id: 'Akhir Pertanggungan',
        label_en: 'End Coverage',
      },
      {
        label_id: 'Manfaat Polis',
        label_en: 'Policy Benefits',
      },
      {
        label_id: 'Batas Polis',
        label_en: 'Policy Limit',
      },
      {
        label_id: 'Biaya Diajukan',
        label_en: 'Proposed Cost',
      },
      {
        label_id: 'Biaya Disetujui',
        label_en: 'Approved Cost',
      },
      {
        label_id: 'Biaya Ditanggung',
        label_en: 'Covered Cost',
      },
      {
        label_id: 'Biaya Tidak Ditanggung',
        label_en: 'Uncovered Cost',
      },
      {
        label_id: 'Informasi Diagnosis',
        label_en: 'Diagnosis Information',
      },
      {
        label_id: 'Perlu diisi!',
        label_en: 'Required!',
      },
      {
        label_id: 'Penyakit',
        label_en: 'Disease',
      },
      {
        label_id:
          'Anda yakin untuk menyetujui ditanggung semuanya? Biaya semua item akan ditanggung semuanya.',
        label_en:
          'Are you sure to approve all covered? The costs of all items will be fully covered.',
      },
      {
        label_id:
          'Anda yakin untuk menolak semuanya? Biaya semua item akan ditolak semuanya.',
        label_en:
          'Are you sure to reject all covered? The costs of all items will be fully rejected.',
      },
      {
        label_id: 'Silakan pilih penyakit dari rekomendasi AI di bawah ini.',
        label_en: 'Please select a disease from the AI recommendations below.',
      },
      {
        label_id: 'Prosedur',
        label_en: 'Procedure',
      },
      {
        label_id: 'Silakan pilih prosedur dari rekomendasi AI di bawah ini.',
        label_en:
          'Please select a procedure from the AI recommendations below.',
      },
      {
        label_id: 'Diagnosis',
        label_en: 'Diagnosis',
      },
      {
        label_id: 'Keluhan Awal',
        label_en: 'Initial Complaint',
      },
      {
        label_id: 'Jenis Perawatan',
        label_en: 'Type Of Treatment',
      },
      {
        label_id: 'Catatan Dokter',
        label_en: 'Doctor Notes',
      },
      // Table Section
      {
        label_id:
          'Konfirmasi Buku Tarif untuk menggunakan Fraud dan Referensi Invoice untuk membuat Estimasi Tagihan',
        label_en:
          'Confirmation of Tariff Book to use Fraud and Invoice Reference to create Billing Estimate',
      },
      {
        label_id: 'Siap dianalisis',
        label_en: 'Ready to be analyzed',
      },
      {
        label_id: 'Sedang dianalisis',
        label_en: 'Being analyzed',
      },
      {
        label_id: 'Mencocokan dengan Relevansi Medis',
        label_en: 'Matching with Medical Relevance',
      },
      {
        label_id:
          'Memverifikasi apakah diagnosis dan tindakan medis sesuai dengan pedoman klinis.',
        label_en:
          'Verifying whether the diagnosis and medical actions are in accordance with clinical guidelines.',
      },
      {
        label_id: 'Membandingkan Invoice dengan Data HET',
        label_en: 'Comparing Invoice with HET Data',
      },
      {
        label_id:
          'Mencari apabila ada item pada invoice yang melebihi harga eceran tertinggi.',
        label_en:
          'Searching for any items on the invoice that exceed the highest retail price.',
      },
      {
        label_id: 'Membandingkan Invoice dengan Buku Tariff',
        label_en: 'Comparing Invoice with Tariff Book',
      },
      {
        label_id:
          'Mencari apabila ada item pada invoice yang melebihi perjanjian harga pada buku tariff.',
        label_en:
          'Searching for any items on the invoice that exceed the agreed price in the tariff book.',
      },
      {
        label_id: 'Membuat Kesimpulan',
        label_en: 'Drawing Conclusion',
      },
      {
        label_id: 'Menyusun ringkasan hasil evaluasi klaim.',
        label_en: 'Summarizing the results of the claim evaluation.',
      },
      {
        label_id: 'Mulai Analisis',
        label_en: 'Start Analysis',
      },
      {
        label_id: 'Mulai Tinjauan',
        label_en: 'Start Review',
      },
      {
        label_id: 'Keputusan',
        label_en: 'Decision',
      },
      {
        label_id: 'Sepakati Klaim',
        label_en: 'Agree on Claim',
      },
      {
        label_id: 'Kirim ke Advisor Lain',
        label_en: 'Send to Another Advisor',
      },
      {
        label_id: 'Revisi Klaim',
        label_en: 'Revise Claim',
      },
      {
        label_id: 'Ajukan Revisi',
        label_en: 'Submit Revision',
      },
      {
        label_id: 'Pilih Advisor',
        label_en: 'Select Advisor',
      },
      {
        label_id: 'Alasan kesepakatan',
        label_en: 'Reason for Agreement',
      },
      {
        label_id: 'Alasan penugasan',
        label_en: 'Reason for Assignment',
      },
      {
        label_id: 'Tulis alasan kesepakatan disini...',
        label_en: 'Write the reason for agreement here...',
      },
      {
        label_id: 'Tulis alasan penugasan disini...',
        label_en: 'Write the reason for assignment here...',
      },
      {
        label_id: 'Silakan pilih advisor lain untuk ditugaskan.',
        label_en: 'Please select another advisor to assign.',
      },
      {
        label_id: 'Status Cakupan',
        label_en: 'Coverage Status',
      },
      {
        label_id: 'Apakah Anda yakin untuk menyepakati klaim?',
        label_en: 'Are you sure you want to agree on the claim?',
      },
      {
        label_id:
          'Apakah Anda yakin untuk mengajukan revisi? Klaim akan dikembalikan ke analis untuk direvisi',
        label_en:
          'Are you sure you want to submit a revision? The claim will be returned to the analyst for revision.',
      },
      {
        label_id: 'Berhasil memulai proses tinjauan',
        label_en: 'Successfully started the review process',
      },
      {
        label_id: 'Berhasil mengubah proses tinjauan',
        label_en: 'Successfully changed the review process',
      },
      {
        label_id: 'Apakah Anda yakin untuk memulai meninjau klaim?',
        label_en: 'Are you sure you want to start reviewing the claim?',
      },
      {
        label_id: 'Menganalisis Cakupan Polis',
        label_en: 'Analyzing Policy Coverage',
      },
      {
        label_id:
          'Memeriksa kesesuaian klaim dengan ketentuan polis dan menghasilkan persetujuan manfaat.',
        label_en:
          'Verifying the claim’s compliance with policy provisions and generating benefit approvals.',
      },
      {
        label_id: 'Membuat Rangkuman',
        label_en: 'Creating Summary',
      },
      {
        label_id:
          'AI akan merangkum poin-poin penting dari hasil analisis klaim.',
        label_en:
          'AI will summarize the key points from the claim analysis results.',
      },
      {
        label_id: 'Cek Eligibilitas & Manfaat',
        label_en: 'Check Eligibility & Benefits',
      },
      {
        label_id: 'Silahkan pilih analis untuk diasign',
        label_en: 'Please select an analyst to assign',
      },
      {
        label_id: 'Pilih Role',
        label_en: 'Please select a role',
      },
      {
        label_id: 'Pilih User',
        label_en: 'Please select a user',
      },
      {
        label_id: 'Pilih Role terlebih dahulu',
        label_en: 'Please select a role first',
      },
      {
        label_id: 'Ajukan Persetujuan',
        label_en: 'Submit Approval',
      },
      {
        label_id: 'Kirim ke Advisor',
        label_en: 'Submit to Advisor',
      },
      {
        label_id: 'Informasi Polis',
        label_en: 'Policy Information',
      },
      {
        label_id: 'Tanggal Pengobatan',
        label_en: 'Treatment Date',
      },
      {
        label_id: 'Nomor Tiket',
        label_en: 'Ticket Number',
      },
      {
        label_id: 'Nomor Member',
        label_en: 'Member Number',
      },
      {
        label_id: 'Nama Penanggung',
        label_en: 'Insured Name',
      },
      {
        label_id: 'Tanggal Efektif Awal',
        label_en: 'Effective Date',
      },
      {
        label_id: 'Tipe Kartu',
        label_en: 'Card Type',
      },
      {
        label_id: 'Informasi Member',
        label_en: 'Member Information',
      },
      {
        label_id: 'Nama Pasien',
        label_en: 'Patient Name',
      },
      {
        label_id: 'Usia Anggota',
        label_en: 'Member Age',
      },
      {
        label_id: 'Anggota',
        label_en: 'Member',
      },
      {
        label_id: 'Pembayaran',
        label_en: 'Payment',
      },
      {
        label_id: 'Pemulihan Kelebihan',
        label_en: 'Overpayment Recovery',
      },
      {
        label_id: 'Nomor Rekening',
        label_en: 'Account Number',
      },
      {
        label_id: 'Nama Bank',
        label_en: 'Bank Name',
      },
      {
        label_id: 'Nama Pemilik Rekening',
        label_en: 'Account Holder Name',
      },
      {
        label_id: 'Cari nama atau email',
        label_en: 'Search by name or email',
      },
      {
        label_id: 'Bandingkan HET',
        label_en: 'Compare HET',
      },
      {
        label_id: 'Ringkasan HET',
        label_en: 'HET Summary',
      },
      {
        label_id: 'Tanggal Proses Klaim',
        label_en: 'Claim Process Date',
      },
      {
        label_id: 'Masuk',
        label_en: 'Admission',
      },
      {
        label_id: 'Keluar',
        label_en: 'Discharge',
      },
      {
        label_id: 'Tambahan',
        label_en: 'Additional',
      },
      {
        label_id: 'Regenerate Ringkasan',
        label_en: 'Regenerate Summary',
      },
      // Section and Modal Eligibility dan Manfaat
      {
        label_id: 'Dokumen Polis',
        label_en: 'Policy Document',
      },
      {
        label_id: 'Ubah Manfaat',
        label_en: 'Edit Benefits',
      },
      {
        label_id: 'Cek Eligibility dan Manfaat',
        label_en: 'Check Eligibility and Benefits',
      },
      {
        label_id: 'Konfirmasi Edit Manfaat Polis',
        label_en: 'Confirm Edit Policy Benefits',
      },
      {
        label_id:
          'Apakah Anda yakin ingin mengubah manfaat polis? Semua perubahan pada tabel manfaat tidak akan disimpan dan akan digenerate kembali.',
        label_en:
          'Are you sure you want to change the policy benefits? All changes to the benefits table will not be saved and will be regenerated.',
      },
      {
        label_id:
          'Apakah Anda yakin untuk mengekstrak data klaim? Silakan periksa kembali kelengkapan dokumen sebelum mengekstrak data.',
        label_en:
          'Are you sure you want to extract claim data? Please double-check the completeness of the documents before extracting data.',
      },
      {
        label_id:
          'Silahkan mengonfirmasi dokumen polis dan plan untuk cek eligibility dan manfaat',
        label_en:
          'Please confirm the policy and plan documents to check eligibility and benefits.',
      },
      {
        label_id:
          'Silahkan mengonfirmasi dokumen polis dan plan untuk cek eligibility klaim',
        label_en:
          'Please confirm the policy and plan documents to check claim eligibility.',
      },
      {
        label_id: 'Plan yang dimiliki dalam enrollment ini',
        label_en: 'Plans that are included in this enrollment',
      },
      {
        label_id: 'Sisa Limit Plan',
        label_en: 'Remaining Plan Limit',
      },
      {
        label_id: 'Sisa Limit Family',
        label_en: 'Remaining Family Limit',
      },
      {
        label_id: 'Total Limit Plan',
        label_en: 'Total Plan Limit',
      },
      {
        label_id: 'Total Limit Family',
        label_en: 'Total Family Limit',
      },
      {
        label_id: 'Presentase Penanggungan',
        label_en: 'Coverage Percentage',
      },
      {
        label_id: 'Daftar Pantauan Khusus',
        label_en: 'Special Watch List',
      },
      {
        label_id: 'dan Dokter',
        label_en: 'and Doctor',
      },
      {
        label_id:
          'masuk dalam daftar pantauan khusus. Silakan tinjau klaim kembali.',
        label_en:
          'are included in the special watch list. Please review the claim again.',
      },
      {
        label_id: 'Potensi Duplikat',
        label_en: 'Potential Duplicate',
      },
      {
        label_id: 'Manfaat Digunakan',
        label_en: 'Benefits Used',
      },
      {
        label_id: 'Sisa Batas Manfaat',
        label_en: 'Remaining Benefit Limit',
      },
      {
        label_id: 'Informasi Plan',
        label_en: 'Plan Information',
      },
      {
        label_id: 'Gagal dikirim',
        label_en: 'Failed to Send',
      },
      {
        label_id: 'Gagal Dikirim ke Core Sistem',
        label_en: 'Failed to Send to Core System',
      },
      {
        label_id:
          'Claim gagal untuk dikirim ke core sistem. Silakan sepakati klaim kembali!',
        label_en:
          'Claim failed to send to the core system. Please agree on the claim again!',
      },
      {
        label_id: 'Riwayat Klaim Peserta',
        label_en: 'Participant Claim History',
      },
      {
        label_id: 'Tulis alasan',
        label_en: 'Write reason',
      },
      {
        label_id: 'penerimaan',
        label_en: 'acceptance',
      },
      {
        label_id: 'penolakan',
        label_en: 'rejection',
      },
      {
        label_id: 'kamu disini',
        label_en: 'you are here',
      },
      {
        label_id: 'Tandai item',
        label_en: 'Mark item',
      },
      {
        label_id: 'Eligibilitas',
        label_en: 'Eligibility',
      },
      {
        label_id: 'Terindikasi',
        label_en: 'Indicated',
      },
      {
        label_id: 'Draft',
        label_en: 'Draft',
      },
      {
        label_id: 'Baru',
        label_en: 'New',
      },
      {
        label_id: 'Pending',
        label_en: 'Pending',
      },
      {
        label_id: 'Siap Diekstrak',
        label_en: 'Ready to Extract',
      },
      {
        label_id: 'Kelayakan Klaim',
        label_en: 'Claim Eligibility',
      },
      {
        label_id: 'Monitoring Klaim',
        label_en: 'Claim Monitoring',
      },
      {
        label_id: 'Unggah Dokumen Akhir',
        label_en: 'Upload Final Document',
      },
      {
        label_id: 'Siap Di Analisis',
        label_en: 'Ready to Analyze',
      },
      {
        label_id: 'Memeriksa FWA',
        label_en: 'Checking FWA',
      },
      {
        label_id: 'Memeriksa Eligibility',
        label_en: 'Checking Eligibility',
      },
      {
        label_id: 'Siap Ditinjau',
        label_en: 'Ready to Review',
      },
      {
        label_id: 'Sedang Ditinjau',
        label_en: 'Approval Ongoing',
      },
      {
        label_id: 'Ditanggung Sepenuhnya',
        label_en: 'Fully Covered',
      },
      {
        label_id: 'Ditanggung Sebagian',
        label_en: 'Partially Covered',
      },
      {
        label_id: 'Tidak ditanggung',
        label_en: 'Not Covered',
      },
      {
        label_id: 'Revisi',
        label_en: 'Revision',
      },
      {
        label_id: 'Dihapus',
        label_en: 'Deleted',
      },
      {
        label_id: 'Informasi Medis',
        label_en: 'Medical Information',
      },
      {
        label_id: 'Informasi Resep Dokter',
        label_en: 'Doctor Prescription Information',
      },
    ],
  },
  {
    page: 'BukuTarif',
    label: [
      {
        label_id: 'Buku Tarif',
        label_en: 'Tariff Book',
      },
      {
        label_id: 'Nama Rumah Sakit',
        label_en: 'Hospital Name',
      },
      {
        label_id: 'Tanggal Mulai',
        label_en: 'Starting Date',
      },
      {
        label_id: 'Pilih Tanggal',
        label_en: 'Select Date',
      },
      {
        label_id: 'Unggah File',
        label_en: 'Upload File',
      },
      {
        label_id: 'Mohon pilih file',
        label_en: 'Please select a file',
      },
      {
        label_id: 'Unggah Buku Tarif',
        label_en: 'Upload Tariff Book',
      },
      {
        label_id: 'Hapus Buku Tarif',
        label_en: 'Delete Tariff Book',
      },
      {
        label_id: 'Buku Tarif Sedang Diproses Oleh Sistem',
        label_en: 'Tariff Book is Being Processed by the System',
      },
      {
        label_id:
          'Silakan cek secara berkala untuk mengetahui status Buku Tarif.',
        label_en:
          'Please check periodically to find out the status of the Tariff Book.',
      },
      {
        label_id: 'Kembali ke List Buku Tarif',
        label_en: 'Back to Tariff Book List',
      },
      {
        label_id: 'Ulangi Unggah Buku Tarif',
        label_en: 'Retry Upload Tariff Book',
      },
      {
        label_id: 'Apakah Anda yakin untuk memproses ulang Buku Tarif ?',
        label_en: 'Are you sure you want to reprocess the Tariff Book?',
      },
      // Alert message
      {
        label_id: 'Tanggal tidak boleh kosong',
        label_en: 'Date cannot be empty',
      },
      {
        label_id: 'Tanggal Mulai tidak boleh kosong!',
        label_en: 'Starting Date cannot be empty!',
      },
      {
        label_id: 'Silakan pilih file',
        label_en: 'Please select a file',
      },
      {
        label_id: 'Gagal mengunggah file!',
        label_en: 'Failed Upload File!',
      },
      {
        label_id: 'Gagal Kirim Buku Tarif!',
        label_en: 'Failed Submit Tariff Book!',
      },
      {
        label_id: 'Gagal mengunggah Buku Tarif!',
        label_en: 'Failed Upload Tariff Book!',
      },
      {
        label_id: 'Gagal mendapatkan data, silakan coba lagi',
        label_en: 'Failed to retrieve data, please try again',
      },
      {
        label_id: 'Silakan pilih file',
        label_en: 'Please select a file',
      },
      {
        label_id: 'Silakan pilih file',
        label_en: 'Please select a file',
      },
      {
        label_id: 'Berhasil menambahkan kategori item',
        label_en: 'Add Item Category Successfully',
      },
      {
        label_id: 'Berhasil memperbarui buku tarif',
        label_en: 'Update Tariff Book Successfully',
      },
      {
        label_id: 'Hapus Buku Tarif Berhasil',
        label_en: 'Delete Tariff Book Successfully',
      },
    ],
  },
  {
    page: 'NonAuth',
    label: [
      {
        label_id: 'Email tidak boleh kosong',
        label_en: 'Email cannot be empty',
      },
      {
        label_id: 'Password tidak boleh kosong',
        label_en: 'Password cannot be empty',
      },
      {
        label_id: 'Email tidak valid',
        label_en: 'Email is not valid',
      },
      {
        label_id: 'Password tidak valid',
        label_en: 'Password is not valid',
      },
      {
        label_id: 'Mohon masukan format yang benar',
        label_en: 'Please enter the correct format',
      },
      {
        label_id: 'Mohon masukan nama kategori',
        label_en: 'Please enter the category name',
      },
      {
        label_id: 'Gagal menyimpan data di localStorage',
        label_en: 'Failed to store data in localStorage',
      },
      {
        label_id: 'Masuk ke Sembuh AI',
        label_en: 'Login to Sembuh AI',
      },
      {
        label_id: 'Masuk untuk mengakses dasbor',
        label_en: 'Login to access the dashboard',
      },
      {
        label_id: 'Lupa Password',
        label_en: 'Forgot Password',
      },
      {
        label_id: 'Lupa Kata Sandi',
        label_en: 'Forgot Password',
      },
      {
        label_id: 'Masuk',
        label_en: 'Login',
      },
      {
        label_id: 'Email Terkirim!',
        label_en: 'Email Sent!',
      },
      {
        label_id:
          'Periksa email Anda untuk mendapatkan tautan perubahan kata sandi',
        label_en: 'Check your email to get change password link',
      },
      {
        label_id:
          'Masukkan alamat email Anda untuk mengakses tautan verifikasi',
        label_en: 'Enter your email address to access the verification link',
      },
      {
        label_id: 'Kirim Tautan Reset',
        label_en: 'Send Reset Link',
      },
      {
        label_id: 'Konfirmasi Kata Sandi tidak boleh kosong',
        label_en: 'Password Confirm cannot be empty',
      },
      {
        label_id: 'Password dan konfirmasi Password tidak cocok!',
        label_en: 'Password and Password Confirmation do not match!',
      },
      {
        label_id: 'Tetapkan Kata Sandi Baru Anda',
        label_en: 'Set Your New Password',
      },
      {
        label_id: 'Masukkan kata sandi baru untuk akun Anda',
        label_en: 'Enter a new password for your account',
      },
      {
        label_id: 'Password Baru',
        label_en: 'New Password',
      },
      {
        label_id: 'Konfirmasi Password Baru',
        label_en: 'New Password Confirmation',
      },
      {
        label_id: 'Atur Ulang Kata Sandi',
        label_en: 'Reset Password',
      },
      {
        label_id: 'Lanjutkan untuk Masuk',
        label_en: 'Continue to Log In',
      },
      {
        label_id: 'Password berhasil di reset!',
        label_en: 'Password Successfully Reset!',
      },
      {
        label_id:
          'kata sandi Anda telah berhasil diperbarui. Anda sekarang dapat masuk ke akun Anda menggunakan kata sandi baru Anda',
        label_en:
          'your password has been updated Successfully. you can now login in to your account using your new password',
      },
      {
        label_id: 'Kode OTP tidak boleh kosong',
        label_en: 'OTP code cannot be empty',
      },
      {
        label_id: 'Kode OTP tidak valid',
        label_en: 'OTP code is not valid',
      },
      {
        label_id:
          'Anda telah 3 kali salah memasukkan OTP. Silakan login ulang.',
        label_en:
          'You have entered the OTP incorrectly 3 times. Please log in again.',
      },
      {
        label_id: 'Verifikasi Kode OTP',
        label_en: 'OTP Verification',
      },
      {
        label_id:
          'Masukkan kode 6-digit yang telah dikirim ke email Anda untuk menyelesaikan verifikasi login.',
        label_en:
          'Enter the 6-digit code sent to your email to complete login verification.',
      },
      {
        label_id: 'Verifikasi sebelum',
        label_en: 'Verify before',
      },
      {
        label_id:
          'Waktu verifikasi kadaluwarsa. Silakan kirim ulang kode kembali.',
        label_en: 'Verification time has expired. Please resend the code.',
      },
      {
        label_id: 'Kirim Ulang Kode',
        label_en: 'Resend Code',
      },
      {
        label_id: 'Kata sandi harus terdiri dari minimal 12 karakter.',
        label_en: 'Password must be at least 12 characters long.',
      },
      {
        label_id: 'Mohon masukan format yang benar',
        label_en: 'Please enter the correct format.',
      },
      {
        label_id:
          'Kata sandi terlalu lemah. Hindari pola sederhana seperti ‘123456789’ atau ‘password’.',
        label_en:
          'Password is too weak. Avoid simple patterns like ‘123456789’ or ‘password’.',
      },
      {
        label_id: 'Kata sandi tidak boleh mengandung alamat email Anda.',
        label_en: 'Password must not contain your email address.',
      },
      {
        label_id:
          'Kata sandi harus terdiri dari minimal 12 karakter. Gunakan kombinasi huruf, angka, dan simbol. Jangan menggunakan nama atau alamat email Anda.',
        label_en:
          'Password must be at least 12 characters long. Use a combination of letters, numbers, and symbols. Do not use your name or email address.',
      },
      {
        label_id: 'Kata sandi tidak boleh mengandung alamat email Anda.',
        label_en: 'Password must not contain your email address.',
      },
      {
        label_id: 'Ganti Kata Sandi',
        label_en: 'Change Password',
      },
      {
        label_id: 'Kirim Tautan Ganti Kata Sandi',
        label_en: 'Send Change Password Link',
      },
    ],
  },
  {
    page: 'Table',
    label: [
      {
        label_id: 'Status',
        label_en: 'Status',
      },
      {
        label_id: 'Pilih Rentang Tanggal',
        label_en: 'Select Range Date',
      },
      {
        label_id: 'Nama Biaya',
        label_en: 'Cost Name',
      },
      {
        label_id: 'Harga',
        label_en: 'Price',
      },
      {
        label_id: 'Harga per Item',
        label_en: 'Price per Item',
      },
      {
        label_id: 'Harga Subtotal',
        label_en: 'Subtotal Price',
      },
      {
        label_id: 'Data Kosong',
        label_en: 'Empty Data',
      },
      {
        label_id: 'Data Tidak Tersedia',
        label_en: 'No data available',
      },
      {
        label_id: 'Kesalahan Jaringan, Internet Terputus',
        label_en: 'Network error, Internet disconnected',
      },
      {
        label_id: 'Baris per tampilan',
        label_en: 'Rows per view',
      },
      {
        label_id: 'dari',
        label_en: 'of',
      },
      {
        label_id: 'Total Invoice',
        label_en: 'Total Invoice',
      },
      {
        label_id: 'Konfirmasi',
        label_en: 'Confirmation',
      },
      {
        label_id: 'Konfirmasi MIMS',
        label_en: 'MIMS Confirmation',
      },
      {
        label_id: 'Konfirmasi Buku Tarif',
        label_en: 'Tariff Book Confirmation',
      },
      {
        label_id: 'Konfirmasi Relevansi Medis',
        label_en: 'Medical Relevance Confirmation',
      },
      {
        label_id: 'Butuh Konfirmasi',
        label_en: 'Needs Confirmation',
      },
      {
        label_id: 'Melebihi HET',
        label_en: 'Exceeds HET',
      },
      {
        label_id: 'Harga Meningkat',
        label_en: 'Inflated Price',
      },
      // table relevansi medis
      {
        label_id: 'Alasan tidak boleh kosong',
        label_en: 'Reason is required',
      },
      {
        label_id: 'Alasan berhasil dikirim',
        label_en: 'Reason submitted successfully',
      },
      {
        label_id: 'Tidak ada data untuk dikirim',
        label_en: 'No data to submit',
      },
      {
        label_id: 'Konfirmasi Penyakit, Prosedur, dan Diagnosis',
        label_en: 'Confirmation of Disease, Procedure, and Diagnosis',
      },
      {
        label_id:
          'Konfirmasi Penyakit, Prosedur, dan Diagnosis untuk melihat relevansi medis',
        label_en:
          'Confirmation of Disease, Procedure, and Diagnosis to view medical relevance',
      },
      {
        label_id: 'Konfirmasi Relevansi Medis',
        label_en: 'Confirmation of Medical Relevance',
      },
      {
        label_id: 'Dikonfirmasi',
        label_en: 'Confirmed',
      },
      {
        label_id: 'Diterima',
        label_en: 'Accepted',
      },
      {
        label_id: 'Ditolak',
        label_en: 'Rejected',
      },
      {
        label_id: 'Setujui Konfirmasi',
        label_en: 'Approve Confirmation',
      },
      {
        label_id: 'Tolak Konfirmasi',
        label_en: 'Reject Confirmation',
      },
      {
        label_id: 'Tolak Manual',
        label_en: 'Reject Manual',
      },
      {
        label_id: 'Tandai',
        label_en: 'Flag',
      },
      {
        label_id: 'Alasan',
        label_en: 'Reason',
      },
      {
        label_id: 'Tulis alasan penerimaan kamu disini',
        label_en: 'Write your acceptance reason here',
      },
      {
        label_id: 'Tulis alasan penolakan kamu disini',
        label_en: 'Write your rejection reason here',
      },
      {
        label_id:
          'Apakah Anda yakin ingin menandai item ini? Item yang ditandai akan dipindahkan ke kategori ditolak dan tidak akan tercover oleh asuransi.',
        label_en:
          'Are you sure you want to flag this item? Flagged items will be moved to the rejected category and will not be covered by insurance.',
      },
    ],
  },
  {
    page: 'All',
    label: [
      {
        label_id: 'Pilih Bahasa',
        label_en: 'Select Language',
      },
      {
        label_id: 'Memuat',
        label_en: 'Loading',
      },
      {
        label_id: 'Memuat...',
        label_en: 'Loading...',
      },
      {
        label_id: 'Hapus',
        label_en: 'Delete',
      },
      {
        label_id: 'Ubah',
        label_en: 'Edit',
      },
      {
        label_id: 'Simpan',
        label_en: 'Save',
      },
      {
        label_id: 'Unggah',
        label_en: 'Upload',
      },
      {
        label_id: 'Batal',
        label_en: 'Cancel',
      },
      {
        label_id: 'Setujui',
        label_en: 'Accept',
      },
      {
        label_id: 'Tolak',
        label_en: 'Reject',
      },
      {
        label_id: 'Cari',
        label_en: 'Search',
      },
      {
        label_id: 'Semua',
        label_en: 'All',
      },
      {
        label_id: 'Selesai',
        label_en: 'Done',
      },
      {
        label_id: 'Coba lagi',
        label_en: 'Retry',
      },
      {
        label_id: 'Penyakit',
        label_en: 'Disease',
      },
      {
        label_id: 'Prosedur',
        label_en: 'Procedure',
      },
      {
        label_id: 'Rumah Sakit',
        label_en: 'Hospital',
      },
      {
        label_id: 'Wilayah',
        label_en: 'Region',
      },
      {
        label_id: 'Tanggal',
        label_en: 'Date',
      },
      {
        label_id: 'Tgl. Pengobatan',
        label_en: 'Treatment Date',
      },
      {
        label_id: 'Tgl. Proses Klaim',
        label_en: 'Claim Process Date',
      },
      {
        label_id: 'Dibatalkan',
        label_en: 'Cancelled',
      },
      {
        label_id: 'Hapus Data',
        label_en: 'Delete Data',
      },
      {
        label_id: 'Seret & Jatuhkan atau Telusuri',
        label_en: 'Drag & Drop or Browse',
      },
      {
        label_id: 'Format yang didukung',
        label_en: 'Supported formats',
      },
      {
        label_id: 'Waktu permintaan habis',
        label_en: 'Request timed out',
      },
      {
        label_id: 'Tidak ada PDF yang tersedia',
        label_en: 'No PDF available',
      },
      {
        label_id: 'Apakah Anda yakin untuk menghapus',
        label_en: 'Are you sure to delete',
      },
      {
        label_id: 'Setelah dihapus, data tidak dapat dipulihkan.',
        label_en: 'Once deleted, the data cannot be recovered.',
      },
      {
        label_id: 'Permintaan dibatalkan',
        label_en: 'Request was cancelled',
      },
      {
        label_id: 'Rumah Sakit tidak boleh kosong',
        label_en: 'Hospital cannot be empty',
      },
      {
        label_id:
          'Permintaan waktu habis. Silakan coba lagi atau periksa koneksi Anda.',
        label_en:
          'Request timed out. Please try again or check your connection',
      },
    ],
  },
  {
    page: 'listUser',
    label: [
      {
        label_id: 'Tambah Pengguna',
        label_en: 'Add User',
      },
      {
        label_id: 'Manajemen - Pengguna',
        label_en: 'User - Management',
      },
      {
        label_id: 'Nama Pengguna',
        label_en: 'User Name',
      },
      {
        label_id: 'Telepon',
        label_en: 'Phone',
      },
      {
        label_id: 'Tambah',
        label_en: 'Add',
      },
      {
        label_id: 'Cari',
        label_en: 'Search',
      },
      {
        label_id: 'Kata Sandi',
        label_en: 'Password',
      },
      {
        label_id: 'Batal',
        label_en: 'Cancel',
      },
      {
        label_id: 'Kirim',
        label_en: 'Submit',
      },
      {
        label_id: 'Ubah',
        label_en: 'Edit',
      },
      {
        label_id: 'Hapus',
        label_en: 'Delete',
      },
      {
        label_id: 'Hak Akses',
        label_en: 'Role',
      },
    ],
  },
  {
    page: 'listRole',
    label: [
      {
        label_id: 'Buat Hak Akses',
        label_en: 'Create Role',
      },
      {
        label_id: 'Manajemen - Hak Akses',
        label_en: 'Role - Management',
      },
      {
        label_id: 'Nama Hak Akses',
        label_en: 'Role Name',
      },
      {
        label_id: 'Akses',
        label_en: 'Access',
      },
      {
        label_id: 'Buat',
        label_en: 'Create',
      },
      {
        label_id: 'Akses Menu',
        label_en: 'Access Menu',
      },

      {
        label_id: 'Kata Sandi',
        label_en: 'Password',
      },
      {
        label_id: 'Batal',
        label_en: 'Cancel',
      },
      {
        label_id: 'Kirim',
        label_en: 'Submit',
      },
      {
        label_id: 'Ubah',
        label_en: 'Edit',
      },
      {
        label_id: 'Hapus',
        label_en: 'Delete',
      },
    ],
  },
  {
    page: 'sidebar',
    label: [
      {
        label_id: 'Asuransi',
        label_en: 'Insurance',
      },
      {
        label_id: 'Portal Asuransi',
        label_en: 'Insurance Portal',
      },
      {
        label_id: 'Buku Tarif',
        label_en: 'Tariff Book',
      },
      {
        label_id: 'Riwayat Klaim',
        label_en: 'Claim History',
      },
      {
        label_id: 'Klaim TPA',
        label_en: 'TPA Claims',
      },
      {
        label_id: 'Manajemen',
        label_en: 'Management',
      },
      {
        label_id: 'Pengguna',
        label_en: 'User',
      },
      {
        label_id: 'Hak Akses',
        label_en: 'Role',
      },
      {
        label_id: 'Keluar',
        label_en: 'Logout',
      },
    ],
  },
  {
    page: 'Edit Informasi Umum',
    label: [
      {
        label_id: 'ID Klaim',
        label_en: 'Claim ID',
      },
      {
        label_id: 'Tanggal Permintaan',
        label_en: 'Request Date',
      },
      {
        label_id: 'Penyedia Asuransi',
        label_en: 'Insurance Provider',
      },
      {
        label_id: 'Penyedia Admisi',
        label_en: 'Admission Provider',
      },
      {
        label_id: 'Jenis Pembayaran',
        label_en: 'Payment Type',
      },
      {
        label_id: 'Nomor Polis',
        label_en: 'Policy Number',
      },
      {
        label_id: 'Plan Name',
        label_en: 'Plan Name',
      },
      {
        label_id: 'Jenis Asuransi',
        label_en: 'Type of Insurance',
      },
      {
        label_id: 'Rumah Sakit',
        label_en: 'Hospital',
      },
      {
        label_id: 'Dokter',
        label_en: 'Doctor',
      },
      {
        label_id: 'Jumlah Transaksi',
        label_en: 'Total Transaction Amount',
      },
      {
        label_id: 'Edit Informasi Umum',
        label_en: 'Edit General Information',
      },
      {
        label_id: 'Ubah Informasi Umum',
        label_en: 'Edit General Information',
      },
      {
        label_id: 'Mengubah Informasi Umum',
        label_en: 'Editing General Information',
      },
      {
        label_id: 'Simpan',
        label_en: 'Save',
      },
      {
        label_id: 'Batal',
        label_en: 'Cancel',
      },
      {
        label_id: 'Masuk',
        label_en: 'Admission',
      },
      {
        label_id: 'Keluar',
        label_en: 'Discharge',
      },
    ],
  },
  {
    page: 'Card Alert AI Confidence Level',
    label: [
      {
        label_id: 'AI confidence berada dibawah',
        label_en: 'AI confidence is below',
      },
      {
        label_id: 'silakan periksa klaim kembali.',
        label_en: 'please recheck the claim.',
      },
    ],
  },
  {
    page: 'Card Note',
    label: [
      {
        label_id: 'Terakhir diedit oleh',
        label_en: 'Last edited by',
      },
    ],
  },
  {
    page: 'Generate Notes',
    label: [
      {
        label_id: 'Tambah Catatan',
        label_en: 'Add Note',
      },
      {
        label_id: 'Ubah Catatan',
        label_en: 'Edit Note',
      },
      {
        label_id: 'Hapus Catatan',
        label_en: 'Delete Note',
      },
      {
        label_id: 'Batal',
        label_en: 'Cancel',
      },
      {
        label_id: 'Simpan',
        label_en: 'Save',
      },
      {
        label_id: 'Berhasil mengubah catatan',
        label_en: 'Successfully edited note',
      },
      {
        label_id: 'Berhasil menambahkan catatan',
        label_en: 'Successfully added note',
      },
      {
        label_id: 'Berhasil menghapus catatan',
        label_en: 'Successfully deleted note',
      },
      {
        label_id: 'Gagal menambahkan catatan',
        label_en: 'Failed to add note',
      },
      {
        label_id: 'Gagal mengubah catatan',
        label_en: 'Failed to edit note',
      },
      {
        label_id: 'Gagal menghapus catatan',
        label_en: 'Failed to delete note',
      },
      {
        label_id: 'Tulis catatan disini',
        label_en: 'Write note here',
      },
      {
        label_id: 'Tulis alasan disini',
        label_en: 'Write reason here',
      },
      {
        label_id: 'Tulis ringkasan disini',
        label_en: 'Write summary here',
      },
      {
        label_id: 'Konfirmasi',
        label_en: 'Confirmation',
      },
      {
        label_id: 'Catatan Persetujuan',
        label_en: 'Approval Note',
      },
      {
        label_id: 'Catatan Revisi',
        label_en: 'Revision Note',
      },
      {
        label_id: 'Klaim menunggu revisi',
        label_en: 'Claim Waiting for Revision',
      },
      {
        label_id:
          'Anda yakin untuk menghapus catatan ini? Semua perubahan yang Anda lakukan akan hilang.',
        label_en:
          'Are you sure you want to delete this note? All changes you made will be lost.',
      },
    ],
  },
  {
    page: 'Expired Link',
    label: [
      {
        label_id: 'Link Sudah Kadaluarsa',
        label_en: 'Link Expired',
      },
      {
        label_id:
          'Link sementara ini telah kadaluarsa. Silakan kembali ke halaman sebelumnya untuk membuat link baru.',
        label_en:
          'This temporary link has expired. Please return to the previous page to create a new link.',
      },
    ],
  },
  {
    page: 'SectionActivityLog',
    label: [
      {
        label_id: 'Log Aktivitas',
        label_en: 'Activity Log',
      },
      {
        label_id: 'Log Aktivitas',
        label_en: 'Activity Log',
      },
      {
        label_id: 'Waktu',
        label_en: 'Time',
      },
      {
        label_id: 'Aktivitas',
        label_en: 'Activity',
      },
      {
        label_id: 'Pengguna',
        label_en: 'User',
      },
      {
        label_id: 'Item',
        label_en: 'Item',
      },
      {
        label_id: 'Sebelum',
        label_en: 'Before',
      },
      {
        label_id: 'Setelah',
        label_en: 'After',
      },
      {
        label_id: 'Pilih rentang tanggal',
        label_en: 'Select date range',
      },
      {
        label_id: 'Menambahkan',
        label_en: 'Adding',
      },
      {
        label_id: 'Mengedit',
        label_en: 'Editing',
      },
      {
        label_id: 'Mengubah',
        label_en: 'Editing',
      },
      {
        label_id: 'Menghapus',
        label_en: 'Deleting',
      },
      {
        label_id: 'Mengajukan Persetujuan',
        label_en: 'Submitting Approval',
      },
      {
        label_id: 'Menyetujui Persetujuan',
        label_en: 'Approving Approval',
      },
      {
        label_id: 'Menginisiasi',
        label_en: 'Initiating',
      },
      {
        label_id: 'Menolak Klaim',
        label_en: 'Rejecting Claim',
      },
      {
        label_id: 'Detail Perubahan',
        label_en: 'Change Details',
      },
      {
        label_id: 'Sebelumnya',
        label_en: 'Before',
      },
      {
        label_id: 'Sesudahnya',
        label_en: 'After',
      },
      {
        label_id: 'Date of Loss (DoL) - Masuk',
        label_en: 'Date of Loss (DoL) - Admission',
      },
      {
        label_id: 'Date of Loss (DoL) - Keluar',
        label_en: 'Date of Loss (DoL) - Discharge',
      },
      {
        label_id: 'Tipe Admisi',
        label_en: 'Admission Type',
      },
      {
        label_id: 'Jenis Admisi',
        label_en: 'Admission Type',
      },
      {
        label_id: 'Jenis Pembayaran',
        label_en: 'Payment Type',
      },
      {
        label_id: 'Penyedia Asuransi',
        label_en: 'Insurance Provider',
      },
      {
        label_id: 'Tanggal Proses Klaim',
        label_en: 'Claim Process Date',
      },
      {
        label_id: 'Nama Dokter',
        label_en: 'Doctor Name',
      },
      {
        label_id: 'Nomor Index',
        label_en: 'Index Number',
      },
      {
        label_id: 'Kategori Klaim',
        label_en: 'Claim Category',
      },
      {
        label_id: 'Kelas Layanan',
        label_en: 'Service Class',
      },
      {
        label_id: 'Nama Asuransi',
        label_en: 'Insurance Name',
      },
      {
        label_id: 'Jenis Admisi',
        label_en: 'Admission Type',
      },
      {
        label_id: 'Catatan Klaim',
        label_en: 'Claim Notes',
      },
      {
        label_id: 'Tanggal Terima Klaim',
        label_en: 'Claim Received Date',
      },
      {
        label_id: 'Tanggal Penerimaan Klaim',
        label_en: 'Claim Received Date',
      },
      {
        label_id: 'Informasi Surat Jaminan & Reimbursement',
        label_en: 'Guarantee Letter & Reimbursement Information',
      },
      {
        label_id: 'Nomor Surat Jaminan',
        label_en: 'Guarantee Letter Number',
      },
      {
        label_id: 'Nomor Surat PP',
        label_en: 'Guarantee Letter Date',
      },
      {
        label_id: 'Tanggal Surat PP',
        label_en: 'Reimbursement Letter Number',
      },
      {
        label_id: 'Tanggal Surat Jaminan',
        label_en: 'Reimbursement Letter Date',
      },
      {
        label_id: 'Alamat Rumah Sakit',
        label_en: 'Hospital Address',
      },
      {
        label_id: 'Wilayah Rumah Sakit',
        label_en: 'Hospital Region',
      },
      {
        label_id: 'Catatan Prosedur',
        label_en: 'Procedure Notes',
      },
      {
        label_id: 'Klinisi',
        label_en: 'Clinician',
      },
      {
        label_id: 'Lokasi Lab',
        label_en: 'Lab Location',
      },
      {
        label_id: 'Item Invoice',
        label_en: 'Invoice Item',
      },
      {
        label_id: 'Urutan',
        label_en: 'Order',
      },
      {
        label_id: 'Urutan',
        label_en: 'Order',
      },
      {
        label_id: 'Terjadi kesalahan saat mengurai konten',
        label_en: 'Error parsing content',
      },
    ],
  },
  {
    page: 'Base Table Excel',
    label: [
      {
        label_id: 'Nama Biaya',
        label_en: 'Cost Name',
      },
      {
        label_id: 'Tanggal',
        label_en: 'Date',
      },
      {
        label_id: 'Kuantitas',
        label_en: 'Quantity',
      },
      {
        label_id: 'Harga per Item',
        label_en: 'Price per Item',
      },
      {
        label_id: 'Harga Referensi',
        label_en: 'Reference Price',
      },
      {
        label_id: 'Catatan',
        label_en: 'Note',
      },
      {
        label_id: 'Sembunyikan',
        label_en: 'Hide',
      },
      {
        label_id: 'Selengkapnya',
        label_en: 'More',
      },
    ],
  },
  {
    page: 'PotensiDuplikat',
    label: [
      {
        label_id: 'Klaim Berpotensi Duplikat',
        label_en: 'Potential Duplicate Claims',
      },
      {
        label_id:
          'Klaim ini mungkin merupakan duplikat karena memiliki Member ID, Diagnosis, Rumah Sakit, dan Tanggal Invoice yang sama. Berikut adalah klaim lain yang memiliki data serupa',
        label_en:
          'This claim may be a duplicate because it has the same Member ID, Diagnosis, Hospital, and Invoice Date. Here are other claims with similar data',
      },
    ],
  },
  {
    page: 'TablePlan',
    label: [
      {
        label_id: 'Batas Biaya',
        label_en: 'Cost Limit',
      },
      {
        label_id: 'Pengguna Member',
        label_en: 'Member Usage',
      },
      {
        label_id: 'Manfaat Polis',
        label_en: 'Policy Benefits',
      },
      {
        label_id: 'Sisa Batas Manfaat',
        label_en: 'Remaining Benefit Limit',
      },
    ],
  },
  {
    page: 'SelectTariffBook',
    label: [
      {
        label_id: 'Silahkan pilih Buku Tariff',
        label_en: 'Please select a Tariff Book',
      },
      {
        label_id:
          'Urutan Buku Tarif telah direkomendasikan oleh AI berdasarkan data yang Anda unggah.',
        label_en:
          'The order of the Tariff Book has been recommended by AI based on the data you uploaded.',
      },
      {
        label_id: 'Silahkan pilih MIMS',
        label_en: 'Please select MIMS',
      },
      {
        label_id:
          'Urutan MIMS untuk dibandingkan telah direkomendasikan oleh AI berdasarkan data yang Anda unggah.',
        label_en:
          'The order of MIMS for comparison has been recommended by AI based on the data you uploaded.',
      },
    ],
  },
  {
    page: 'SelectMIMSModal',
    label: [
      {
        label_id: 'Silahkan pilih',
        label_en: 'Please select',
      },
      {
        label_id: 'Urutan',
        label_en: 'Order',
      },
      {
        label_id:
          'untuk dibandingkan telah direkomendasikan oleh AI berdasarkan data yang Anda unggah.',
        label_en:
          'for comparison has been recommended by AI based on the data you uploaded.',
      },
    ],
  },
  {
    page: 'SelectHETModal',
    label: [
      {
        label_id: 'Silahkan pilih HET',
        label_en: 'Please select HET',
      },

      {
        label_id:
          'Urutan HET untuk dibandingkan telah direkomendasikan oleh AI berdasarkan data yang Anda unggah',
        label_en:
          'Order of HET for comparison has been recommended by AI based on the data you uploaded.',
      },
    ],
  },
  {
    page: 'StaticStatus',
    label: [
      {
        label_id: 'Draft',
        label_en: 'Draft',
      },
      {
        label_id: 'Baru',
        label_en: 'New',
      },
      {
        label_id: 'Pending',
        label_en: 'Pending',
      },
      {
        label_id: 'Siap Diekstrak',
        label_en: 'Ready to Extract',
      },
      {
        label_id: 'Kelayakan Klaim',
        label_en: 'Claim Eligibility',
      },
      {
        label_id: 'Monitoring Klaim',
        label_en: 'Claim Monitoring',
      },
      {
        label_id: 'Unggah Dokumen Akhir',
        label_en: 'Upload Final Document',
      },
      {
        label_id: 'Siap Di Analisis',
        label_en: 'Ready to Analyze',
      },
      {
        label_id: 'Memeriksa FWA',
        label_en: 'Checking FWA',
      },
      {
        label_id: 'Memeriksa Eligibility',
        label_en: 'Checking Eligibility',
      },
      {
        label_id: 'Siap Ditinjau',
        label_en: 'Ready to Review',
      },
      {
        label_id: 'Sedang Ditinjau',
        label_en: 'Approval Ongoing',
      },
      {
        label_id: 'Ditanggung Sepenuhnya',
        label_en: 'Fully Covered',
      },
      {
        label_id: 'Ditanggung Sebagian',
        label_en: 'Partially Covered',
      },
      {
        label_id: 'Tidak ditanggung',
        label_en: 'Not Covered',
      },
      {
        label_id: 'Revisi',
        label_en: 'Revision',
      },
      {
        label_id: 'Dihapus',
        label_en: 'Deleted',
      },
    ],
  },
  {
    page: 'DetailFraudModal',
    label: [
      {
        label_id: 'Rincian Invoice',
        label_en: 'Invoice Details',
      },
      {
        label_id: 'Nama Item',
        label_en: 'Item Name',
      },
      {
        label_id: 'Harga',
        label_en: 'Price',
      },
      {
        label_id: 'Buku Tarif',
        label_en: 'Tariff Book',
      },
    ],
  },
  {
    page: 'DetailViewBukuTarif',
    label: [
      {
        label_id: 'Insurance Portal',
        label_en: 'Insurance Portal',
      },
      {
        label_id: 'Detail Buku Tarif',
        label_en: 'Detail Tariff Book',
      },
    ],
  },
  {
    page: 'CardElement',
    label: [
      {
        label_id: 'Selengkapnya',
        label_en: 'More',
      },
      {
        label_id: 'Sembunyikan',
        label_en: 'Hide',
      },
    ],
  },
  {
    page: 'ModalUploadAdditionalDocuments',
    label: [
      {
        label_id: 'Upload Dokumen Tambahan',
        label_en: 'Upload Additional Documents',
      },
    ],
  },
];
